// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-27T17:10:18.344Z
// Property: Motif (ID: 6767906449167150)
// Collections: 49 amenities, 16 floorplans (live), 26 photos, 41 POIs, 1 reviews, 6 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5726763346821120",
  "multihub_property_id": "6767906449167150",
  "property_external_id": "1125096",
  "property_zillow_url": null,
  "property_apartments_url": "https://www.apartments.com/phoenix-az/2-bedrooms/5/",
  "property_google_business_url": "https://www.google.com/maps/place/Motif/data=!4m2!3m1!1s0x0:0x33a0d941bcf6335f?sa=X&ved=2ahUKEwij9eTv2YOTAxXzkmoFHRg0GZQQ_BJ6BAgWEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "47754697593",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "motif",
  "property_name": "Motif",
  "property_website_url": "https://www.motifapartmenthomes.com",
  "property_domain": "https://www.motifapartmenthomes.com",
  "property_address": "2529 West Cactus Rd.",
  "property_full_address": "2529 West Cactus Rd., Phoenix, AZ, 85029",
  "property_address_1": "2529 West Cactus Rd.",
  "property_address_2": null,
  "property_address_city": "Phoenix",
  "property_address_state": "AZ",
  "property_address_zip_full": null,
  "property_address_zip": "85029",
  "property_address_country": "US",
  "property_address_county": "Maricopa County",
  "property_neighborhood_address": "North Mountain Village",
  "property_address_latitude": "33.5958",
  "property_address_longitude": "-112.1144",
  "property_email": "Motif@weidner.com",
  "property_phone": "9285881618",
  "property_call_tracking_phone": "623-738-3560",
  "property_company_name": "Weidner Apartment Homes",
  "property_company_url": "https://www.weidner.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "At Motif in vibrant Phoenix, AZ, find your ideal living space among spacious one, two, and three-bedroom floor plans. Enjoy amenities like a refreshing pool, state-of-the-art fitness center, and beautifully landscaped grounds. Revel in the comfort of individual balconies or patios, creating your personal oasis. Your new home awaits!",
  "property_long_description": "**Welcome to Motif: Your Ideal Apartment Community in Phoenix, AZ**\n\nDiscover the perfect blend of comfort and style at Motif, where our thoughtfully designed floor plans offer one, two, and three-bedroom options to fit your lifestyle needs. Each apartment showcases oversized windows, brushed nickel fixtures, and modern amenities, creating a warm and inviting atmosphere. Select units feature elegant granite countertops, faux stone flooring, and cozy wood-burning fireplaces—ideal for those chilly Phoenix evenings.\n\nAt Motif, we pride ourselves on our exceptional amenities tailored for your convenience and enjoyment. Take advantage of our on-site laundry facilities, business center, and fitness center to meet your needs. Enjoy leisurely afternoons by the beautiful pool or host gatherings in our picnic area equipped with grills, sundeck, and outdoor BBQ space. For pet lovers, our dog-friendly policy ensures every family member feels at home.\n\nOur community's prime location offers easy access to public transportation, making your commute a breeze. With an attentive property manager and on-site maintenance team, you can rest easy knowing your home is in good hands. Take advantage of our online services, including rent payments and maintenance requests, for a hassle-free living experience.\n\nMotif is designed for modern living, featuring smoke-free surroundings and beautifully landscaped grounds that provide a tranquil escape right in the heart of Phoenix. \n\nFind your new home today—browse our availability or schedule a tour to visit our community! Experience the Motif difference—where comfort meets convenience.",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d270f-3ffd-76cf-bc88-3c73c325dbfa.webp",
  "property_featured_image_media": {
    "alt_text": "Outdoor swimming pool with lounge chairs and tables.",
    "public_id": "019d270f-3ffd-76cf-bc88-3c73c325dbfa",
    "storage_key": "property/6767906449167150/019d270f-3ffd-76cf-bc88-3c73c325dbfa.webp",
    "width": 1920,
    "height": 702
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "696",
  "property_year_built": "1986",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "94.54022988505747",
  "property_admin_fee": null,
  "property_application_fee": "60",
  "property_fees_deposit_info": "500",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "200",
  "property_pet_deposit": "200",
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Breed restrictions apply",
  "property_pet_policy_description": "Pets – Max 2 Allowed. Monthly pet rent: $25 per pet. Non‑Refundable pet fee: $200 per pet. Refundable pet deposit: $200 per pet. Cats & dogs are welcome (no weight limit), with breed restrictions (e.g., Pit Bull & mixes, Doberman, Rottweiler, German Shepherd, Great Dane, Akita, etc.). Other small pets (hamsters, birds, turtles, fish) allowed; tropical fish limited to a 20‑gallon tank. Fees and pet limit apply only to cats and dogs; service animals allowed.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://motifapartmenthomes.securecafe.com/onlineleasing/motif-1/floorplans.aspx",
  "property_resident_portal_url": "https://motifapartmenthomes.securecafenet.com/residentservices/motif-1/userlogin",
  "property_apply_now_url": "https://motifapartmenthomes.securecafe.com/onlineleasing/motif-1/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d270f-47ee-722e-b463-f913a38c772b.webp",
  "property_primary_logo_media": {
    "alt_text": "Motif Apartment Homes logo",
    "public_id": "019d270f-47ee-722e-b463-f913a38c772b",
    "storage_key": "property/6767906449167150/019d270f-47ee-722e-b463-f913a38c772b.webp",
    "width": 379,
    "height": 150
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d270f-4f09-73d2-a0bf-8e177c6db40b.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Motif Apartment Homes logo",
    "public_id": "019d270f-4f09-73d2-a0bf-8e177c6db40b",
    "storage_key": "property/6767906449167150/019d270f-4f09-73d2-a0bf-8e177c6db40b.webp",
    "width": 379,
    "height": 150
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d270f-54d1-736b-a831-f2aaaff9af87.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Motif Apartment Homes logo",
    "public_id": "019d270f-54d1-736b-a831-f2aaaff9af87",
    "storage_key": "property/6767906449167150/019d270f-54d1-736b-a831-f2aaaff9af87.webp",
    "width": 379,
    "height": 150
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-4291-7593-82c0-efd4c864db24.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
  "property_company_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d0198-5322-7081-947b-e809ba802b6c",
    "storage_key": "company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
    "width": 1342,
    "height": 402
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-bdc5-779e-a400-a391326cc801",
    "storage_key": "company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
    "width": 640,
    "height": 192
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-c548-748f-97de-b042810ed358",
    "storage_key": "company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
    "width": 640,
    "height": 192
  },
  "property_primary_color": "#583635",
  "property_secondary_color": "#8496b1",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": " - 1209",
  "property_sqft_min": "621",
  "property_sqft_max": "1209",
  "property_price_range": "894 - 2905",
  "property_price_min": "894",
  "property_price_max": "2905",
  "property_available_units": 51,
  "property_facebook_url": "https://www.facebook.com/MotifApartmentHomesAZ/",
  "property_instagram_url": "https://www.instagram.com/motifapts/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJQbUgyTxsK4cRXzP2vEHZoDM",
  "property_youtube_url": "https://www.youtube.com/@WeidnerApartmentHomes",
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Motif",
  "property_home_romance_title": "Embrace a Beautiful Life in Your New Apartment Home",
  "property_home_amenities_blurb": "Welcome to Motif, where ranch-style comfort meets modern convenience in sunny Phoenix. Choose from spacious one, two, or three-bedroom layouts featuring oversized windows, cozy fireplaces, and inviting breakfast nooks. Enjoy our beautifully landscaped grounds, lounge by the pool, or connect effortlessly with online services—all tailored for your vibrant lifestyle.",
  "property_home_floorplans_blurb": "Welcome to Motif in vibrant Phoenix, AZ, where contemporary design meets comfort. Our thoughtfully crafted floor plans cater to every lifestyle, ensuring you find the perfect fit for your needs. Embrace the charm of our community—browse available apartment homes today and envision your ideal living space!",
  "property_home_gallery_blurb": "Welcome to Motif, where modern living meets comfort in vibrant Phoenix, AZ. Choose from spacious one, two, or three-bedroom floor plans designed to suit your lifestyle. With stellar amenities like a refreshing pool, fitness center, and beautifully landscaped grounds, life here is a blend of relaxation and excitement. Picture yourself living here!",
  "property_home_neighborhood_blurb": "Welcome to Motif, your serene oasis in Phoenix, AZ! Choose from our thoughtfully designed one, two, or three-bedroom apartments, just steps away from Shaw Butte School and Mountain Sky Middle School. Enjoy vibrant community life with access to local favorites, parks, and educational landmarks nearby.",
  "property_home_reviews_blurb": "At Motif in vibrant Phoenix, AZ, residents rave about the “exceptional sense of community and modern amenities.” Experience a lifestyle where comfort meets convenience, and find your perfect home amid lush landscapes and engaging activities. Curious to know more? See what our residents have to say about living at our community!",
  "property_neighborhood_blurb": "At Motif in Phoenix, AZ, your new home places you in vibrant proximity to esteemed educational institutions, including Shaw Butte School, Mountain Sky Middle School, and Thunderbird High School. Enjoy easy access to exceptional learning environments while embracing a community that's rich in opportunity. See what's around our community and explore local favorites!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "Welcome to Motif, where modern living meets style in vibrant Phoenix, AZ. Our thoughtfully designed one, two, and three-bedroom apartments boast oversized windows, beautiful courtyards, and a range of premium amenities—from a sparkling pool to a cozy coffee bar. Experience the lifestyle you deserve with us!",
  "property_applynow_blurb": "At Motif in Phoenix, AZ, spacious floor plans and remarkable amenities await your discovery. Choose from one, two, or three-bedroom apartments featuring vaulted ceilings, oversized windows, and modern kitchens with granite countertops. Relax by the pool, enjoy the sun on your balcony, or fire up the grill in our beautiful courtyard—your perfect home is just a click away!",
  "property_contactus_blurb": "At Motif in Phoenix, AZ, find your ideal living space with our diverse floor plans—choose from one, two, or three-bedroom apartments tailored to fit your lifestyle. Ready for a fresh start? Our leasing team is just a message away. Have questions? Contact us today!",
  "property_faqs_blurb": "At Motif in Phoenix, AZ, we offer a variety of spacious floor plans, from cozy one-bedroom retreats to expansive three-bedroom homes. Curious about our vibrant community? Navigate to our FAQs page for insights and answers tailored just for you! A new lifestyle awaits in the desert sun.",
  "property_floorplans_blurb": "At Motif in Phoenix, AZ, your dream home awaits with our thoughtfully designed floor plans. Choose from spacious one, two, or three-bedroom apartments that seamlessly blend style and comfort. Each layout is crafted to enhance your lifestyle. Browse our available apartment homes and find the perfect fit for you today!",
  "property_gallery_blurb": "At Motif in Phoenix, AZ, our vibrant community invites you to envision your ideal lifestyle. Picture yourself lounging by the pool, enjoying sun-drenched courtyards, or unwinding on your private balcony. With spacious floor plans and exceptional amenities, home feels like a getaway. Let’s make those visions a reality!",
  "property_interactivemap_blurb": "Welcome to Motif, where every apartment is a canvas of comfort in the heart of Phoenix, AZ. Choose from an array of thoughtfully designed floor plans featuring stunning amenities like oversized windows, a refreshing pool, and a cozy lounge. Use our interactive community map today to find your perfect space!",
  "property_pets_blurb": "At Motif in Phoenix, furry companions are part of the family! With a welcoming policy for cats and dogs, your pets can thrive in our vibrant community. Enjoy spacious living while your pets enjoy their own adventures, all within a stylish, pet-friendly environment perfect for making memories together!",
  "property_referafriend_blurb": "At Motif in vibrant Phoenix, AZ, our spacious one, two, and three-bedroom floor plans are designed for comfort and style. Great friends make great neighbors—share the joy of community living by referring a friend today! Experience the unique lifestyle that awaits at Motif, where home truly comes alive.",
  "property_residentaccess_blurb": "Welcome to Motif in vibrant Phoenix, AZ! Enjoy the flexibility of our thoughtfully designed floor plans, featuring one, two, or three-bedroom options. Log in to your resident portal for hassle-free rent payments, maintenance requests, and updates, ensuring your living experience is as seamless as your stylish new home!",
  "property_reviews_blurb": "At Motif in Phoenix, AZ, residents rave about their vibrant community, stating it’s “an inviting oasis with friendly neighbors and stunning amenities.” Hear firsthand how life at Motif transcends ordinary living. See what our residents have to say about living at our community!",
  "property_created_at": "1771530666204",
  "property_scheduletour_blurb": "At Motif in Phoenix, AZ, our thoughtfully designed one, two, and three-bedroom apartments offer comfortable living tailored to your lifestyle. Schedule a tour today and experience the vibrant community that makes our residents proud to call Motif home. Check out their testimonials to see why they love living here!",
  "property_thankyou_blurb": "Thank you for your interest in Motif, your future sanctuary in Phoenix, AZ! Whether you seek a cozy one-bedroom retreat or spacious three-bedroom living, we offer floor plans tailored for every lifestyle. Our team will connect with you soon to help you envision your new home at Motif!",
  "property_virtualtours_blurb": "Welcome to Motif in sunny Phoenix, AZ, where style meets comfort in our diverse floor plans. Whether you're seeking a cozy one-bedroom or a spacious three-bedroom, you'll find your perfect fit. Immerse yourself in our vibrant community—take a virtual tour today and envision your new home!",
  "property_copyright": "2026 All Rights Reserved. Motif",
  "property_seo_title_home": "Motif |  Apartments in Phoenix, AZ",
  "property_seo_description_home": "Welcome to Motif in Phoenix, AZ—where modern comforts meet vibrant living with beautiful amenities and spacious floor plans!",
  "property_seo_title_floorplans": "Floor Plans | Phoenix, AZ Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal living space at Motif in Phoenix! Browse 1, 2, and 3-bedroom floor plans tailored for comfort and style. Your new home awaits!",
  "property_seo_title_amenities": "Amenities | Phoenix, AZ Apartments for Rent",
  "property_seo_description_amenities": "Experience a vibrant lifestyle at Motif in Phoenix, AZ! Enjoy spacious floor plans, lush amenities, and a welcoming community tailored just for you.",
  "property_seo_title_gallery": "Gallery | Apartments in Phoenix, AZ",
  "property_seo_description_gallery": "Envision your ideal life at Motif in Phoenix! Enjoy stylish one to three-bedroom homes with fantastic amenities, including a pool and private patios.",
  "property_seo_title_virtualtours": "Virtual Tours | Motif Apartments",
  "property_seo_description_virtualtours": "Experience the vibrant life at Motif in Phoenix, AZ! Take a virtual tour of our stunning one, two, and three-bedroom apartments. Your new home awaits!",
  "property_seo_title_interactivemap": "Interactive Map | Motif Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at Motif in Phoenix, AZ! Use our interactive map to explore stylish one, two, and three-bedroom apartments with top-notch amenities.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Phoenix, AZ",
  "property_seo_description_neighborhood": "Discover vibrant Phoenix at Motif, with local favorites and hotspots just steps from your stylish one, two, or three-bedroom apartment.",
  "property_seo_title_contact": "Contact Us | Motif",
  "property_seo_description_contact": "Connect with Motif in Phoenix, AZ! Explore our one, two, and three-bedroom floor plans. Have questions? Reach out to our leasing team today!",
  "property_seo_title_faqs": "FAQs | Apartments in Phoenix, AZ",
  "property_seo_description_faqs": "Uncover essential insights about Motif Apartments in Phoenix, AZ. Get answers to your FAQs and see why living here offers comfort and convenience.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Phoenix, AZ",
  "property_seo_description_reviews": "Join the Motif community in Phoenix, AZ, where modern living meets comfort. Check out our residents' experiences and see why they love calling us home!",
  "property_seo_title_applynow": "Apply Now | Apartments in Phoenix, AZ",
  "property_seo_description_applynow": "Discover your ideal home at Motif in Phoenix! Spacious layouts, great amenities, and a lively community await. Apply online for easy leasing!",
  "property_seo_title_residentaccess": "Resident Access | Motif",
  "property_seo_description_residentaccess": "Log in to Motif’s resident portal in Phoenix to effortlessly manage rent payments, schedule maintenance, and access community updates—all in one place!",
  "property_seo_title_referafriend": "Refer A Friend | Motif",
  "property_seo_description_referafriend": "Refer a friend to Motif in Phoenix, AZ! Enjoy vibrant living and a welcoming community where great friends become great neighbors. Share the joy today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Motif",
  "property_seo_description_scheduletour": "Experience vibrant living at Motif in Phoenix, AZ. Schedule your tour today and uncover the perfect blend of comfort, style, and convenience!",
  "property_seo_title_privacy": "Privacy Policy | Motif",
  "property_seo_description_privacy": "Safeguarding your peace of mind at Motif in Phoenix. Dive into our Privacy Policy to see how we protect your personal information. Transparency starts here!",
  "property_seo_title_accessibility": "Website Accessibility | Motif",
  "property_seo_description_accessibility": "Experience true inclusivity at Motif, Phoenix, AZ. We're dedicated to accessibility for all. Join us in embracing digital inclusion!",
  "property_seo_title_sitemap": "Sitemap | Motif",
  "property_seo_description_sitemap": "Navigate Motif's vibrant community in Phoenix, AZ! Our sitemap guides you to discover amenities, floor plans, and events that make living here extraordinary.",
  "property_seo_title_thankyou": "Thank You | Motif",
  "property_seo_description_thankyou": "Thank you for reaching out! A Motif team member will connect with you soon. Your future home in vibrant Phoenix awaits—stay tuned for exciting updates!",
  "property_seo_title_pets": "Pet Policy | Apartments in Phoenix, AZ",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293659641",
  "amenities": [
    {
      "id": "ec_bda1448115f7c20abab0f570",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "generator",
      "external_id": "false",
      "title": "Online Payments Available",
      "amount": "false",
      "description": "Free e‑check option ; Accepts credit card payments ; Accepts cash payments via MoneyGram.",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_174eef4e7f3e99161b4713ce",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "generator",
      "external_id": "false",
      "title": "24 Hour Emergency Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_619e5f5883936929a9c8a5cd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "generator",
      "external_id": "false",
      "title": "Accepts Credit Card Payments",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8833dcdb62939381bc4095cb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "generator",
      "external_id": "false",
      "title": "Beautifully Landscaped Grounds",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_981b20e1de4a07122d0d1968",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "generator",
      "external_id": "false",
      "title": "Coffee Bar",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_00be046ecd956f78d88c0d92",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "generator",
      "external_id": "false",
      "title": "Complementary Covered Parking",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a3dec7b6c12f794e0ed84676",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "generator",
      "external_id": "false",
      "title": "Fitness Center with Cardio and Strength Training",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9b30abb5b2da6e51bb7589be",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "generator",
      "external_id": "false",
      "title": "Flexible Lease Terms",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_63b3d887b7576146346d2dc6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "generator",
      "external_id": "false",
      "title": "Four Refreshing Pools",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_167ccd2ee8f9fc0c93558ffc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "generator",
      "external_id": "false",
      "title": "Near Public Transit",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_541d72480739174c03e02bdd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "generator",
      "external_id": "false",
      "title": "Online Rent Payment",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_42401d7600506c314337ec3c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "generator",
      "external_id": "false",
      "title": "Online Service Requests",
      "amount": "false",
      "description": "Online service requests available.",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dde5a31b091d93dac271ad16",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "generator",
      "external_id": "false",
      "title": "On‑Site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6a2ce8e4034ea79af947253c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "generator",
      "external_id": "false",
      "title": "On‑site Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c6075cc063c1c8894bf22c3c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "generator",
      "external_id": "false",
      "title": "Outdoor BBQ area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e4b1dec19de96cd424bf2760",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "generator",
      "external_id": "false",
      "title": "Dog and Cat Friendly",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dd6a571359a4b88e1ebab984",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "generator",
      "external_id": "false",
      "title": "Pool Views",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ea208eea065d08bea63992cf",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "generator",
      "external_id": "false",
      "title": "Resident Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_031194c1827f21f5ceeb9d3f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "generator",
      "external_id": "false",
      "title": "Sports Court",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9f16f72e1bcfa9502e33002e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "generator",
      "external_id": "false",
      "title": "Sundeck",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e7745956019455cfbc24b20d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "generator",
      "external_id": "false",
      "title": "Smoke‑Free Community",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0063d5a233b0c87c7832a842",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "generator",
      "external_id": "false",
      "title": "Ceiling Fans*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4892d1e72a3518165c7545ab",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "generator",
      "external_id": "false",
      "title": "Granite Countertops",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_da5a5d4b1ce6827ae8cde9e0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "generator",
      "external_id": "false",
      "title": "Updated Light Fixtures Throughout",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_226c5919b5318b8b9f683300",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "generator",
      "external_id": "false",
      "title": "Woodgrain Vinyl",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dd519d16eaf6d411b2e88caa",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "generator",
      "external_id": "false",
      "title": "Nine Foot Ceilings*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8138f85baff400ef702ef7e8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "generator",
      "external_id": "false",
      "title": "Black Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a4403d2642a58b62159c9ec7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "generator",
      "external_id": "false",
      "title": "Pecan Cabinetry",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0648c1b434f0f6cd51088637",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "generator",
      "external_id": "false",
      "title": "Washer and Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_824c69445b3effce273fd776",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "generator",
      "external_id": "false",
      "title": "Air Conditioner",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2fbcff54271cdc8b5e2ebb91",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "generator",
      "external_id": "false",
      "title": "Breakfast Nooks*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_19985ebe7972bce949c51c0a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "generator",
      "external_id": "false",
      "title": "Brushed Nickel Hardware/Fixtures",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_01a6069c9f50d92265efda35",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "generator",
      "external_id": "false",
      "title": "Built In Bookshelves",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_290383d4f62f6f206ff8c7c1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "generator",
      "external_id": "false",
      "title": "Custom Accent Walls",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a81a64e2ed96943a02181b3c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "generator",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ab9e77c8cae03b462e6e75b0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "generator",
      "external_id": "false",
      "title": "Electric range",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_25d71aca421655b4617ef01a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "generator",
      "external_id": "false",
      "title": "Faux Stone Flooring*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fbb76b330bda87f9489bc65c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "generator",
      "external_id": "false",
      "title": "Full Size Refrigerator",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b74a50f8c3e1c2c67a1b1d88",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "generator",
      "external_id": "false",
      "title": "Individual Storage Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f6bc5fa80d9bc20045444f98",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "generator",
      "external_id": "false",
      "title": "Kitchen Pantry",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_972af7eec9a20908b67c5aef",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "generator",
      "external_id": "false",
      "title": "Linen Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e774d6a5454d28d803ee4431",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "generator",
      "external_id": "false",
      "title": "Outside Storage",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_31b3359f1eb38aa6899c6cde",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "generator",
      "external_id": "false",
      "title": "Premium Lighting Packages*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a06d54554286fec9a64cdfb1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "generator",
      "external_id": "false",
      "title": "Private Patios/Balconies",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_577dbecf4d936cc1913283d2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "generator",
      "external_id": "false",
      "title": "1 Month of Free High‑Speed Internet Courtesy of Cox Communications",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_16b48b70adbc07f034306a23",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "generator",
      "external_id": "false",
      "title": "Wood Burning Fireplaces",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c46767cf5fd51912f820e751",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "generator",
      "external_id": "false",
      "title": "Oversized Windows",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1b6c5caded1914029a5fcf0e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "generator",
      "external_id": "false",
      "title": "Deep Stainless Steel Sinks",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_76f6d0afc56b1d32f1c25743",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "generator",
      "external_id": "false",
      "title": "Cox Quick Connect",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_ea74fdc679555483db2ca69d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0217-ba8d-721a-9c4b-5fe5a8b6853e.webp",
      "image_media": {
        "alt_text": "Living room with a sofa, chairs, coffee table, and entryway.",
        "public_id": "019d0217-ba8d-721a-9c4b-5fe5a8b6853e",
        "storage_key": "property/6767906449167150/019d0217-ba8d-721a-9c4b-5fe5a8b6853e.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Spacious and well-lit living room featuring comfortable seating, decorative elements, and a convenient entryway.",
      "link": "false",
      "alt_text": "Living room with a sofa, chairs, coffee table, and entryway.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Motif_Favorites (1).jpg"
    },
    {
      "id": "ec_b45344741bf1201802c60045",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019e2f5f-1474-77ee-8172-1fd52f79baa7.webp",
      "image_media": {
        "alt_text": "Ask about our summer specials available now!",
        "public_id": "019e2f5f-1474-77ee-8172-1fd52f79baa7",
        "storage_key": "property/6767906449167150/019e2f5f-1474-77ee-8172-1fd52f79baa7.webp",
        "width": 1084,
        "height": 684
      },
      "title": "Other",
      "description": "Summer specials are available now. Restrictions apply. Specials, pricing and availability subject to change daily. Contact the leasing office for details. Equal Housing Opportunity.",
      "link": "false",
      "alt_text": "Ask about our summer specials available now!",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/Specials (3179).png"
    },
    {
      "id": "ec_928182b498fc12c56d7836c9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0217-b9d1-736b-921d-83f7971a2aee.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area in an apartment.",
        "public_id": "019d0217-b9d1-736b-921d-83f7971a2aee",
        "storage_key": "property/6767906449167150/019d0217-b9d1-736b-921d-83f7971a2aee.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Spacious living and dining area with an open-concept kitchen. Perfect for entertaining.",
      "link": "false",
      "alt_text": "Living room and kitchen area in an apartment.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Motif_Favorites (2).jpg"
    },
    {
      "id": "ec_6675b39502c47e777f494c3e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0217-ba88-7181-80d0-ca313eea56b9.webp",
      "image_media": {
        "alt_text": "Living room with couch, armchair, coffee table, and decor. Window overlooks pool area.",
        "public_id": "019d0217-ba88-7181-80d0-ca313eea56b9",
        "storage_key": "property/6767906449167150/019d0217-ba88-7181-80d0-ca313eea56b9.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Stylish living room featuring a comfortable couch, accent chair, and a modern coffee table. Enjoy views of the pool area through the large window.",
      "link": "false",
      "alt_text": "Living room with couch, armchair, coffee table, and decor. Window overlooks pool area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Motif_Favorites (3).jpg"
    },
    {
      "id": "ec_8437fb719bd796702e7e9b62",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0217-c4c7-76b8-88cf-dae808f2bd34.webp",
      "image_media": {
        "alt_text": "Modern dining area and open kitchen with wooden cabinets and granite countertops.",
        "public_id": "019d0217-c4c7-76b8-88cf-dae808f2bd34",
        "storage_key": "property/6767906449167150/019d0217-c4c7-76b8-88cf-dae808f2bd34.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Experience comfortable living in this apartment, featuring a stylish dining area adjacent to a well-equipped open kitchen with beautiful wooden cabinets and granite countertops.",
      "link": "false",
      "alt_text": "Modern dining area and open kitchen with wooden cabinets and granite countertops.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Motif_Favorites (4).jpg"
    },
    {
      "id": "ec_238c6f8fe7cd56e195482939",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0217-c4f3-75ea-8f59-9467b42e465c.webp",
      "image_media": {
        "alt_text": "Kitchen sink and countertops with a view of the living room.",
        "public_id": "019d0217-c4f3-75ea-8f59-9467b42e465c",
        "storage_key": "property/6767906449167150/019d0217-c4f3-75ea-8f59-9467b42e465c.webp",
        "width": 2560,
        "height": 1707
      },
      "title": "Apartment",
      "description": "Modern kitchen with granite countertops, double sink, and a view into the open-plan living area, perfect for entertaining.",
      "link": "false",
      "alt_text": "Kitchen sink and countertops with a view of the living room.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Motif_Favorites (5).jpg"
    },
    {
      "id": "ec_7b3070793b6c3923a440cd8a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0217-c529-710b-bd91-476f7c29868d.webp",
      "image_media": {
        "alt_text": "Modern kitchen with granite countertops, stainless steel sink, and black appliances.",
        "public_id": "019d0217-c529-710b-bd91-476f7c29868d",
        "storage_key": "property/6767906449167150/019d0217-c529-710b-bd91-476f7c29868d.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "A clean and updated kitchen featuring ample cabinet space, granite countertops, and modern black appliances, perfect for preparing meals.",
      "link": "false",
      "alt_text": "Modern kitchen with granite countertops, stainless steel sink, and black appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Motif_Favorites (6).jpg"
    },
    {
      "id": "ec_1e988a4b73bf374020387105",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0217-c56c-7427-a7a2-a613cd479b39.webp",
      "image_media": {
        "alt_text": "Modern kitchen with granite countertops, stainless steel sink, and black appliances.",
        "public_id": "019d0217-c56c-7427-a7a2-a613cd479b39",
        "storage_key": "property/6767906449167150/019d0217-c56c-7427-a7a2-a613cd479b39.webp",
        "width": 1200,
        "height": 675
      },
      "title": "Apartment",
      "description": "Beautifully appointed kitchen featuring granite countertops, ample cabinet space, and modern black appliances, perfect for culinary enthusiasts.",
      "link": "false",
      "alt_text": "Modern kitchen with granite countertops, stainless steel sink, and black appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Motif_Favorites (7).jpg"
    },
    {
      "id": "ec_ee7739e162fc431dae77468f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0217-cec7-7665-97f9-ca05c9a11f75.webp",
      "image_media": {
        "alt_text": "Kitchen with light wood cabinets, black appliances, and a granite countertop.",
        "public_id": "019d0217-cec7-7665-97f9-ca05c9a11f75",
        "storage_key": "property/6767906449167150/019d0217-cec7-7665-97f9-ca05c9a11f75.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Stylish kitchen featuring light wood cabinetry, a sleek black microwave and stove, and elegant granite countertops. A breakfast bar with stools offers a casual dining option.",
      "link": "false",
      "alt_text": "Kitchen with light wood cabinets, black appliances, and a granite countertop.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Motif_Favorites (8).jpg"
    },
    {
      "id": "ec_3e93bc25bcea511ee74dfafe",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0217-cfa1-706c-95be-23815eaa022a.webp",
      "image_media": {
        "alt_text": "Primary bedroom with king-size bed, two nightstands with lamps, and ceiling fan.",
        "public_id": "019d0217-cfa1-706c-95be-23815eaa022a",
        "storage_key": "property/6767906449167150/019d0217-cfa1-706c-95be-23815eaa022a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious primary bedroom featuring a comfortable king-size bed, elegant nightstands with lamps, and a ceiling fan for added comfort.",
      "link": "false",
      "alt_text": "Primary bedroom with king-size bed, two nightstands with lamps, and ceiling fan.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Motif_Favorites (9).jpg"
    },
    {
      "id": "ec_a6ff0b7e18bbded1dce51679",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0217-d175-7104-988a-cf9a9adaa915.webp",
      "image_media": {
        "alt_text": "A well-appointed bedroom featuring a queen-size bed with decorative pillows and a ceiling fan.",
        "public_id": "019d0217-d175-7104-988a-cf9a9adaa915",
        "storage_key": "property/6767906449167150/019d0217-d175-7104-988a-cf9a9adaa915.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully furnished bedroom, complete with a queen-size bed, ample storage, and a ceiling fan for year-round comfort.",
      "link": "false",
      "alt_text": "A well-appointed bedroom featuring a queen-size bed with decorative pillows and a ceiling fan.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Motif_Favorites (10).jpg"
    },
    {
      "id": "ec_6d7ee91869a8a7763cf06f8a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0217-d534-738d-9628-421a6a24eb36.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, nightstands, and a ceiling fan.",
        "public_id": "019d0217-d534-738d-9628-421a6a24eb36",
        "storage_key": "property/6767906449167150/019d0217-d534-738d-9628-421a6a24eb36.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed bedroom, featuring a plush king-size bed, elegant nightstands with lamps, and a ceiling fan for optimal comfort.",
      "link": "false",
      "alt_text": "Bedroom with a king-size bed, nightstands, and a ceiling fan.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Motif_Favorites (11).jpg"
    },
    {
      "id": "ec_8322bc4c5111b12276bc911d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0217-d9e3-725d-8c51-905b52e58c22.webp",
      "image_media": {
        "alt_text": "Clean and bright bathroom with a white tiled shower and tub, striped shower curtain, toilet, and a vanity with a granite countertop and modern fixtures.",
        "public_id": "019d0217-d9e3-725d-8c51-905b52e58c22",
        "storage_key": "property/6767906449167150/019d0217-d9e3-725d-8c51-905b52e58c22.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Step into this clean and inviting bathroom, featuring a pristine white tiled shower and tub combination, complemented by a stylish striped shower curtain. The vanity offers ample space with a granite countertop and modern fixtures, perfect for your daily routine.",
      "link": "false",
      "alt_text": "Clean and bright bathroom with a white tiled shower and tub, striped shower curtain, toilet, and a vanity with a granite countertop and modern fixtures.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Motif_Favorites (12).jpg"
    },
    {
      "id": "ec_5efa5b4c36327f1ca5684c95",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0217-dbb8-716e-8cd1-164d0c97fdd2.webp",
      "image_media": {
        "alt_text": "In-unit washer and dryer with overhead shelf.",
        "public_id": "019d0217-dbb8-716e-8cd1-164d0c97fdd2",
        "storage_key": "property/6767906449167150/019d0217-dbb8-716e-8cd1-164d0c97fdd2.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Convenient in-unit washer and dryer with an overhead shelf for storage.",
      "link": "false",
      "alt_text": "In-unit washer and dryer with overhead shelf.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Motif_Favorites (13).jpg"
    },
    {
      "id": "ec_a351818a7c817fbbae3d0bdb",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0217-de9b-76ed-9a65-a73be1a7f6f4.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
        "public_id": "019d0217-de9b-76ed-9a65-a73be1a7f6f4",
        "storage_key": "property/6767906449167150/019d0217-de9b-76ed-9a65-a73be1a7f6f4.webp",
        "width": 2560,
        "height": 1707
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by lush landscaping and comfortable lounge chairs. Perfect for relaxing and soaking up the sun.",
      "link": "false",
      "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Motif_Favorites (14).jpg"
    },
    {
      "id": "ec_831d32606ddd18bde05a4127",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0217-df80-750b-8767-629e72c8e02b.webp",
      "image_media": {
        "alt_text": "Large swimming pool with lounge chairs and a tropical island in the center.",
        "public_id": "019d0217-df80-750b-8767-629e72c8e02b",
        "storage_key": "property/6767906449167150/019d0217-df80-750b-8767-629e72c8e02b.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by lush landscaping and comfortable lounge chairs for ultimate relaxation.",
      "link": "false",
      "alt_text": "Large swimming pool with lounge chairs and a tropical island in the center.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Motif_Favorites (15).jpg"
    },
    {
      "id": "ec_25f668fef95f60000748c5c8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0217-e56d-7473-ab60-1ec8ca94bd85.webp",
      "image_media": {
        "alt_text": "Sparkling swimming pool with lounge chairs and palm trees.",
        "public_id": "019d0217-e56d-7473-ab60-1ec8ca94bd85",
        "storage_key": "property/6767906449167150/019d0217-e56d-7473-ab60-1ec8ca94bd85.webp",
        "width": 2560,
        "height": 1707
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our resort-style swimming pool, surrounded by lush landscaping and comfortable lounge seating.",
      "link": "false",
      "alt_text": "Sparkling swimming pool with lounge chairs and palm trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Motif_Favorites (16).jpg"
    },
    {
      "id": "ec_a2bfd2f9c73d27009aa171dc",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0217-e94d-71fa-bbed-3b965d092b99.webp",
      "image_media": {
        "alt_text": "Fitness center with cardio machines, free weights, and bench.",
        "public_id": "019d0217-e94d-71fa-bbed-3b965d092b99",
        "storage_key": "property/6767906449167150/019d0217-e94d-71fa-bbed-3b965d092b99.webp",
        "width": 2560,
        "height": 1707
      },
      "title": "Community",
      "description": "Our spacious fitness center offers a variety of cardio machines, a weight bench, and free weights for your workout needs.",
      "link": "false",
      "alt_text": "Fitness center with cardio machines, free weights, and bench.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Motif_Favorites (17).jpg"
    },
    {
      "id": "ec_95b665a72add68596d6f4e8e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0217-ec98-776c-84bf-3103184b7df3.webp",
      "image_media": {
        "alt_text": "Fitness center with weight machines and cardio equipment",
        "public_id": "019d0217-ec98-776c-84bf-3103184b7df3",
        "storage_key": "property/6767906449167150/019d0217-ec98-776c-84bf-3103184b7df3.webp",
        "width": 2560,
        "height": 1707
      },
      "title": "Community",
      "description": "Our state-of-the-art fitness center offers a variety of cardio machines and weight training equipment for residents to stay active.",
      "link": "false",
      "alt_text": "Fitness center with weight machines and cardio equipment",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Motif_Favorites (18).jpg"
    },
    {
      "id": "ec_3c5d3ce431a89673ffb5db13",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0217-eefa-7270-a368-90354fffddd3.webp",
      "image_media": {
        "alt_text": "Gym with weight machines and treadmills",
        "public_id": "019d0217-eefa-7270-a368-90354fffddd3",
        "storage_key": "property/6767906449167150/019d0217-eefa-7270-a368-90354fffddd3.webp",
        "width": 2560,
        "height": 1707
      },
      "title": "Community",
      "description": "State-of-the-art fitness center with a variety of weight machines and cardio equipment for residents to enjoy.",
      "link": "false",
      "alt_text": "Gym with weight machines and treadmills",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Motif_Favorites (19).jpg"
    },
    {
      "id": "ec_5db15ab2253db51f45541435",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0217-f3ef-71bd-8d5a-f440d4510eb3.webp",
      "image_media": {
        "alt_text": "Gym with exercise bikes, treadmills, and weight machines.",
        "public_id": "019d0217-f3ef-71bd-8d5a-f440d4510eb3",
        "storage_key": "property/6767906449167150/019d0217-f3ef-71bd-8d5a-f440d4510eb3.webp",
        "width": 1200,
        "height": 675
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring cardio equipment, strength-training machines, and free weights for residents.",
      "link": "false",
      "alt_text": "Gym with exercise bikes, treadmills, and weight machines.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Motif_Favorites (20).jpg"
    },
    {
      "id": "ec_a3339f1f659c4d9a1a831058",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0217-f713-77ba-8437-662d41ffd3b8.webp",
      "image_media": {
        "alt_text": "Lobby area with seating, fireplace, TV, and refreshment station.",
        "public_id": "019d0217-f713-77ba-8437-662d41ffd3b8",
        "storage_key": "property/6767906449167150/019d0217-f713-77ba-8437-662d41ffd3b8.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "The welcoming lobby features comfortable seating, a modern fireplace, a large TV, and a refreshment station, creating a sophisticated and inviting atmosphere for residents.",
      "link": "false",
      "alt_text": "Lobby area with seating, fireplace, TV, and refreshment station.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Motif_Favorites (21).jpg"
    },
    {
      "id": "ec_8cead278e515bd96aed90682",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0217-fa9b-75fc-98b8-23e65e37c26e.webp",
      "image_media": {
        "alt_text": "Community business center with computers and desks.",
        "public_id": "019d0217-fa9b-75fc-98b8-23e65e37c26e",
        "storage_key": "property/6767906449167150/019d0217-fa9b-75fc-98b8-23e65e37c26e.webp",
        "width": 2560,
        "height": 1707
      },
      "title": "Community",
      "description": "Stay connected in our community business center, equipped with computers and desks for your convenience.",
      "link": "false",
      "alt_text": "Community business center with computers and desks.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Motif_Favorites (22).jpg"
    },
    {
      "id": "ec_f485757ead1b99a6a7a76b21",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0217-fafe-776d-b85d-6de97ed24cbf.webp",
      "image_media": {
        "alt_text": "Stylish refreshment station with a sink, coffee maker, mini-fridges, and decorative shelving.",
        "public_id": "019d0217-fafe-776d-b85d-6de97ed24cbf",
        "storage_key": "property/6767906449167150/019d0217-fafe-776d-b85d-6de97ed24cbf.webp",
        "width": 2560,
        "height": 1707
      },
      "title": "Community",
      "description": "Enjoy complimentary refreshments at our well-appointed station, featuring a coffee maker, mini-fridges stocked with drinks, and a stylish sink area.",
      "link": "false",
      "alt_text": "Stylish refreshment station with a sink, coffee maker, mini-fridges, and decorative shelving.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Motif_Favorites (23).jpg"
    },
    {
      "id": "ec_479e630669e4aa46ba5e8202",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0218-01af-709f-9077-00a54cab084e.webp",
      "image_media": {
        "alt_text": "Community room with tables and chairs set up for an event.",
        "public_id": "019d0218-01af-709f-9077-00a54cab084e",
        "storage_key": "property/6767906449167150/019d0218-01af-709f-9077-00a54cab084e.webp",
        "width": 2560,
        "height": 1707
      },
      "title": "Community",
      "description": "Gather your friends and family in our spacious community room, perfect for hosting events and celebrations.",
      "link": "false",
      "alt_text": "Community room with tables and chairs set up for an event.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Motif_Favorites (24).jpg"
    },
    {
      "id": "ec_819d53fadc4b03c7db713978",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0218-067e-7768-bfb1-d470793ace14.webp",
      "image_media": {
        "alt_text": "Front entrance of a multifamily property with a welcome sign.",
        "public_id": "019d0218-067e-7768-bfb1-d470793ace14",
        "storage_key": "property/6767906449167150/019d0218-067e-7768-bfb1-d470793ace14.webp",
        "width": 2560,
        "height": 1707
      },
      "title": "Community",
      "description": "Welcome to the inviting entrance of our multifamily property, featuring a paved walkway leading to glass double doors and a charming 'Thank You Thursday!' sign.",
      "link": "false",
      "alt_text": "Front entrance of a multifamily property with a welcome sign.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Motif_Favorites (25).jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_2ec45575-3631-4f44-8f95-df26b010a5c7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "custom",
      "poi_name": "Bobby-Q BBQ Restaurant and Steakhouse",
      "poi_type": "Restaurants",
      "poi_address": "8501 N 27th Ave, Phoenix, AZ 85051, USA",
      "poi_short_description": "Family-friendly eatery serving steak, BBQ ribs & other American comfort items in a rustic setting.",
      "poi_long_description": "People say this barbecue restaurant serves delicious ribs, brisket, and pulled pork, and the Q rolls and cornbread are highly recommended. They highlight the generous portions, reasonable prices, and the complimentary donuts at the end of the meal. They also like the friendly and attentive service, and the fun, lively atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0219-09dd-73dc-9642-3a368404ab50.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0219-09dd-73dc-9642-3a368404ab50",
        "storage_key": "property/6767906449167150/019d0219-09dd-73dc-9642-3a368404ab50.webp",
        "width": 1124,
        "height": 634
      },
      "poi_business_url": "https://bobbyqbbq.com/phoenix-bbq-restaurant/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11940719194717959783&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bobby-q-bbq-restaurant-and-steakhouse",
      "poi_latitude": "33.560937",
      "poi_longitude": "-112.1158642",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 602-995-5982",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0218-cf02-732e-be92-c1a6df49c848.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-cf02-732e-be92-c1a6df49c848",
        "storage_key": "property/6767906449167150/019d0218-cf02-732e-be92-c1a6df49c848.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8dBh__RsK4cRZzbay9f0taU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_8ce1e772-ec5e-41ba-86ff-261793656801",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "custom",
      "poi_name": "Pappadeaux Seafood Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "11051 N Black Cyn Hwy, Phoenix, AZ 85029, USA",
      "poi_short_description": "Cajun-style seafood, pastas & comfort fare served in a dark wood eatery with a full bar.",
      "poi_long_description": "People say this seafood restaurant serves fresh and flavorful seafood, including gumbo, shrimp salad, and crab cakes. They highlight the generous portions, the lively and beautiful atmosphere, and the attentive service. They also like the outdoor water fountain and surrounding plant life.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0219-09d4-71c8-8fa1-6075be51222f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0219-09d4-71c8-8fa1-6075be51222f",
        "storage_key": "property/6767906449167150/019d0219-09d4-71c8-8fa1-6075be51222f.webp",
        "width": 886,
        "height": 349
      },
      "poi_business_url": "https://pappadeaux.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13477599013761038707&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pappadeaux-seafood-kitchen",
      "poi_latitude": "33.587819",
      "poi_longitude": "-112.1158724",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 602-331-3434",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0218-cf02-732e-be92-c1a6df49c848.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-cf02-732e-be92-c1a6df49c848",
        "storage_key": "property/6767906449167150/019d0218-cf02-732e-be92-c1a6df49c848.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8Wnq1T1sK4cRc7lhSOUMCrs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_73d0c610-064d-4138-ac8e-026462f84c66",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "custom",
      "poi_name": "Golden Corral Buffet & Grill",
      "poi_type": "Restaurants",
      "poi_address": "5679 W Northern Ave, Glendale, AZ 85301, USA",
      "poi_short_description": "Family-friendly buffet chain featuring all-you-can-eat American fare, plus salad & dessert bars.",
      "poi_long_description": "Diners say this buffet restaurant offers a wide variety of comfort food, including pot roast, fried chicken, steak, and a fresh salad bar, with many praising the delicious yeast rolls and extensive dessert selection. They also highlight the friendly and attentive staff, and the great value for the price, especially during off-peak hours.\n\nSome reviews mention the food can be inconsistent in quality.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0219-09ac-7353-ad3d-8a4b75f8ffd9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0219-09ac-7353-ad3d-8a4b75f8ffd9",
        "storage_key": "property/6767906449167150/019d0219-09ac-7353-ad3d-8a4b75f8ffd9.webp",
        "width": 960,
        "height": 721
      },
      "poi_business_url": "https://www.goldencorral.com/locations/2530/golden-corral-w-northern-avenue?utm_source=google&utm_medium=local&utm_campaign=localmaps&utm_content=2530",
      "poi_directions_map_url": "https://maps.google.com/?cid=16146451116213055299&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "golden-corral-buffet--grill",
      "poi_latitude": "33.552664",
      "poi_longitude": "-112.181616",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 28 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 623-937-0866",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0218-cf02-732e-be92-c1a6df49c848.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-cf02-732e-be92-c1a6df49c848",
        "storage_key": "property/6767906449167150/019d0218-cf02-732e-be92-c1a6df49c848.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJoc_4NKhrK4cRQ68WHb63E-A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "buffet_restaurant"
    },
    {
      "id": "custom_410b189f-6b0a-42e4-af5d-e3cf1863693b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "custom",
      "poi_name": "Culinary Dropout",
      "poi_type": "Restaurants",
      "poi_address": "5632 N 7th St, Phoenix, AZ 85014, USA",
      "poi_short_description": "Cool, British-style gastropub chain with quirky decor, serving inventive cocktails & comfort food.",
      "poi_long_description": "Diners say this American restaurant serves up delicious brussel sprouts, fried chicken, fish and chips, and pretzel bites, and they praise the lively atmosphere with outdoor seating, cornhole, and ping pong. They also highlight the friendly and attentive service, and many appreciate the complimentary valet parking.\n\nSome reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0219-09d5-75dd-bd83-d2e636c93594.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0219-09d5-75dd-bd83-d2e636c93594",
        "storage_key": "property/6767906449167150/019d0219-09d5-75dd-bd83-d2e636c93594.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.culinarydropout.com/locations/phoenix-az/?utm_source=Google&utm_medium=Organic&utm_campaign=Maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=2103499372696634781&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "culinary-dropout",
      "poi_latitude": "33.519589",
      "poi_longitude": "-112.0654512",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 40 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 602-680-4040",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0218-cf02-732e-be92-c1a6df49c848.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-cf02-732e-be92-c1a6df49c848",
        "storage_key": "property/6767906449167150/019d0218-cf02-732e-be92-c1a6df49c848.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJh6g1AroSK4cRnQXX3oghMR0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_67c555d4-219b-4854-918a-1bb0a8dadf72",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "custom",
      "poi_name": "Little Miss BBQ-Sunnyslope",
      "poi_type": "Restaurants",
      "poi_address": "8901 N 7th St, Phoenix, AZ 85020, USA",
      "poi_short_description": "Barbecue specialty shop for brisket and other smoked meats and sides, plus beer and wine.",
      "poi_long_description": "People say this barbecue restaurant serves tender brisket, flavorful ribs, and delicious sides like mac and cheese and jalapeño cheddar grits. They highlight the generous portions, the smoky aroma, and the friendly and hospitable staff. They also like the clean and spacious dining area, and the large patio with misters.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0219-0e8f-7552-83e7-1f6b98c99189.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0219-0e8f-7552-83e7-1f6b98c99189",
        "storage_key": "property/6767906449167150/019d0219-0e8f-7552-83e7-1f6b98c99189.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.littlemissbbq.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4179398957250748695&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "little-miss-bbq-sunnyslope",
      "poi_latitude": "33.566205",
      "poi_longitude": "-112.064784",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 602-314-6922",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0218-cf02-732e-be92-c1a6df49c848.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-cf02-732e-be92-c1a6df49c848",
        "storage_key": "property/6767906449167150/019d0218-cf02-732e-be92-c1a6df49c848.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJZds6MIptK4cRF6GRTTU1ADo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_0a95d2cc-f15c-40f7-8249-a25eb0ef15a8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "custom",
      "poi_name": "Asiana Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "4410 W Union Hills Dr A-1, Glendale, AZ 85308, USA",
      "poi_short_description": "Bright, spacious grocery store carrying imported Asian foods as well as fresh produce & housewares.",
      "poi_long_description": "People say this grocery store offers a wide variety of Asian products, including Korean, Malaysian, Indian, and Middle Eastern foods, as well as fresh produce and a deli counter. They also highlight the friendly and helpful staff, and the clean and well-organized space.\n\nSome reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0219-0e7f-728a-b147-679acd1aa450.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0219-0e7f-728a-b147-679acd1aa450",
        "storage_key": "property/6767906449167150/019d0219-0e7f-728a-b147-679acd1aa450.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://asianamarket2.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13013496231028009135&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "asiana-market",
      "poi_latitude": "33.6553254",
      "poi_longitude": "-112.1542391",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 623-780-1234",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0218-cf4b-75ae-8392-35059f4c4679.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-cf4b-75ae-8392-35059f4c4679",
        "storage_key": "property/6767906449167150/019d0218-cf4b-75ae-8392-35059f4c4679.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1y6QdM9oK4cRryhPqN85mbQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_grocery_store"
    },
    {
      "id": "custom_7e44727a-df57-4601-9d32-f9dde65edd6b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "custom",
      "poi_name": "WinCo Foods",
      "poi_type": "Shopping & Retail",
      "poi_address": "330 W Bell Rd, Phoenix, AZ 85023, USA",
      "poi_short_description": "Employee-owned 24/7 supermarket chain with discounted groceries & bulk foods, plus a deli & bakery.",
      "poi_long_description": "People say this supermarket offers a wide selection of fresh produce, meat, and bulk items, including spices, candy, and baking supplies. They highlight the low prices, convenient 24-hour opening hours, and self-checkout option. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0218-823b-717d-a65f-47fc37a3ffb3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0218-823b-717d-a65f-47fc37a3ffb3",
        "storage_key": "property/6767906449167150/019d0218-823b-717d-a65f-47fc37a3ffb3.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://wincofoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14777022528232851537&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "winco-foods",
      "poi_latitude": "33.641162",
      "poi_longitude": "-112.079758",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 602-978-2730",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0218-cf4b-75ae-8392-35059f4c4679.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-cf4b-75ae-8392-35059f4c4679",
        "storage_key": "property/6767906449167150/019d0218-cf4b-75ae-8392-35059f4c4679.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMaQMRERuK4cRUYhDibKHEs0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_310e0589-3884-4acb-ab81-af839ce6a7bd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "custom",
      "poi_name": "Lee Lee International Supermarkets",
      "poi_type": "Shopping & Retail",
      "poi_address": "7575 W Cactus Rd, Peoria, AZ 85381, USA",
      "poi_short_description": "Spacious ethnic grocery with fresh produce, meat, seafood & foods imported from 30+ countries.",
      "poi_long_description": "People say this Asian grocery store offers a wide variety of international foods, including fresh produce, seafood, spices, and snacks from various countries. They highlight the reasonable prices and the fun, adventurous shopping experience. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0219-0e2e-76da-a23e-017542146dba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0219-0e2e-76da-a23e-017542146dba",
        "storage_key": "property/6767906449167150/019d0219-0e2e-76da-a23e-017542146dba.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.leeleesupermarket.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15297342196616545134&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lee-lee-international-supermarkets",
      "poi_latitude": "33.5946741",
      "poi_longitude": "-112.221928",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 623-773-3345",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0218-cf4b-75ae-8392-35059f4c4679.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-cf4b-75ae-8392-35059f4c4679",
        "storage_key": "property/6767906449167150/019d0218-cf4b-75ae-8392-35059f4c4679.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLUxnwPFpK4cRbkPs1K0TS9Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_grocery_store"
    },
    {
      "id": "custom_6d32bfba-d9f1-4bea-bd93-d4f9ced9f2df",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "custom",
      "poi_name": "Bookmans Phoenix Entertainment Exchange",
      "poi_type": "Shopping & Retail",
      "poi_address": "8034 N 19th Ave, Phoenix, AZ 85021, USA",
      "poi_short_description": "Established business buying, selling & trading used books, music, movies, video games & instruments.",
      "poi_long_description": "People say this used book store offers a wide array of media and book options, including books, CDs, vinyl, video games, instruments, toys, and knick-knacks. They highlight the store is fun, comfortable, and inviting, with a huge selection and organized layout. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0219-12d6-745a-8e55-49ac0788d9e3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0219-12d6-745a-8e55-49ac0788d9e3",
        "storage_key": "property/6767906449167150/019d0219-12d6-745a-8e55-49ac0788d9e3.webp",
        "width": 1084,
        "height": 614
      },
      "poi_business_url": "http://www.bookmans.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16140797074585927479&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bookmans-phoenix-entertainment-exchange",
      "poi_latitude": "33.5542174",
      "poi_longitude": "-112.1010025",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 602-433-0255",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0218-cf05-71b8-8cab-7e37e41e94b5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-cf05-71b8-8cab-7e37e41e94b5",
        "storage_key": "property/6767906449167150/019d0218-cf05-71b8-8cab-7e37e41e94b5.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ2RiWEuNsK4cRN79b9muh_98",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "book_store"
    },
    {
      "id": "custom_8faebaf9-34b7-4e05-8c3e-642b3e325e37",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "custom",
      "poi_name": "Grand Canyon University",
      "poi_type": "Education",
      "poi_address": "3300 W Camelback Rd, Phoenix, AZ 85017, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0219-1403-7151-abd1-9744909cd482.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0219-1403-7151-abd1-9744909cd482",
        "storage_key": "property/6767906449167150/019d0219-1403-7151-abd1-9744909cd482.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.gcu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14902340455442424245&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "grand-canyon-university",
      "poi_latitude": "33.5100339",
      "poi_longitude": "-112.1288588",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 602-639-7500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0218-d271-7607-86a7-69586b5cfc49.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-d271-7607-86a7-69586b5cfc49",
        "storage_key": "property/6767906449167150/019d0218-d271-7607-86a7-69586b5cfc49.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJj7t3FE4TK4cRtSGUMLC_z84",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_2fc4e3bd-f2e5-4f58-8f38-1105c3033cf2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "custom",
      "poi_name": "Glendale Community College",
      "poi_type": "Education",
      "poi_address": "6000 W Olive Ave, Glendale, AZ 85302, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0219-13b6-735f-a566-945d4ea81600.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0219-13b6-735f-a566-945d4ea81600",
        "storage_key": "property/6767906449167150/019d0219-13b6-735f-a566-945d4ea81600.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.gccaz.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=954649757192534245&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "glendale-community-college",
      "poi_latitude": "33.5694333",
      "poi_longitude": "-112.1908271",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 623-845-3333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0218-d271-7607-86a7-69586b5cfc49.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-d271-7607-86a7-69586b5cfc49",
        "storage_key": "property/6767906449167150/019d0218-d271-7607-86a7-69586b5cfc49.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ52NxVbVrK4cR5bhfbuWYPw0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_66a8344e-ac12-48c2-ba0c-b5e883afd6b5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "custom",
      "poi_name": "Arizona State University West Valley Campus",
      "poi_type": "Education",
      "poi_address": "4701 W Thunderbird Rd, Glendale, AZ 85306, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0219-1533-7594-82d8-8a384880fa6c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0219-1533-7594-82d8-8a384880fa6c",
        "storage_key": "property/6767906449167150/019d0219-1533-7594-82d8-8a384880fa6c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://campus.asu.edu/west-valley",
      "poi_directions_map_url": "https://maps.google.com/?cid=14857680985714674109&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "arizona-state-university-west-valley-campus",
      "poi_latitude": "33.6079039",
      "poi_longitude": "-112.1609696",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 602-543-5500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0218-d271-7607-86a7-69586b5cfc49.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-d271-7607-86a7-69586b5cfc49",
        "storage_key": "property/6767906449167150/019d0218-d271-7607-86a7-69586b5cfc49.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJi7CNmFxpK4cRvUmZGyMWMc4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_d4b47820-9ba6-4e51-99fc-14729a72e750",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "custom",
      "poi_name": "Arizona Christian University",
      "poi_type": "Education",
      "poi_address": "1 W Firestorm Wy, Glendale, AZ 85306, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.arizonachristian.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4384916488308923584&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "arizona-christian-university",
      "poi_latitude": "33.6224173",
      "poi_longitude": "-112.1824525",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 602-489-5300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0218-d271-7607-86a7-69586b5cfc49.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-d271-7607-86a7-69586b5cfc49",
        "storage_key": "property/6767906449167150/019d0218-d271-7607-86a7-69586b5cfc49.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJufvuEVBpK4cRwBxoV1Ba2jw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_f308e5df-abab-476e-9be0-84a4c83ff265",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "custom",
      "poi_name": "ASU WEST",
      "poi_type": "Education",
      "poi_address": "7000 University Way N, Glendale, AZ 85306, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://campus.asu.edu/west-valley",
      "poi_directions_map_url": "https://maps.google.com/?cid=17607851155726739029&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "asu-west",
      "poi_latitude": "33.6090958",
      "poi_longitude": "-112.160189",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0218-d271-7607-86a7-69586b5cfc49.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-d271-7607-86a7-69586b5cfc49",
        "storage_key": "property/6767906449167150/019d0218-d271-7607-86a7-69586b5cfc49.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJW3qhzzppK4cRVSYL81WnW_Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_a42babab-089b-4006-9f48-7b7f5e890967",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "custom",
      "poi_name": "Castles N' Coasters",
      "poi_type": "Entertainment",
      "poi_address": "9445 N Metro Pkwy E, Phoenix, AZ 85051, USA",
      "poi_short_description": "Family-friendly destination for mini-golf, go-kart rides, roller coasters & an arcade.",
      "poi_long_description": "People say this amusement park offers a variety of fun rides, mini golf courses, and arcade games. They also highlight the reasonable prices, especially with the unlimited ride pass, and the fun, family-friendly atmosphere.\n\nOther reviews mention the rides can be closed during certain times.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0218-928f-7645-a441-e8b13b53133e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0218-928f-7645-a441-e8b13b53133e",
        "storage_key": "property/6767906449167150/019d0218-928f-7645-a441-e8b13b53133e.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.castlesncoasters.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14386602448939149210&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "castles-n-coasters",
      "poi_latitude": "33.5725174",
      "poi_longitude": "-112.1188154",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 602-997-7575",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0218-d264-771b-9ddb-8894427d400b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-d264-771b-9ddb-8894427d400b",
        "storage_key": "property/6767906449167150/019d0218-d264-771b-9ddb-8894427d400b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_____xgSK4cRmmfILbR6p8c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_1c209d0e-689f-4ab0-9ff5-dbf0e362e4ef",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "custom",
      "poi_name": "Martin Auto Museum and Event Center",
      "poi_type": "Entertainment",
      "poi_address": "4320 W Thunderbird Rd, Glendale, AZ 85306, USA",
      "poi_short_description": "Fascinating space featuring over 170 cars spanning 130 years of history such as hot rods and Shelby Cobras.",
      "poi_long_description": "People say this museum offers a vast collection of vintage and classic cars, as well as a carousel and game room. They highlight the affordable price, the opportunity to sit in many of the cars, and the clean and well-maintained facilities. They also like the friendly, knowledgeable, and welcoming staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0219-18b2-766a-9a2e-7acc798aab7b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0219-18b2-766a-9a2e-7acc798aab7b",
        "storage_key": "property/6767906449167150/019d0219-18b2-766a-9a2e-7acc798aab7b.webp",
        "width": 828,
        "height": 466
      },
      "poi_business_url": "https://www.martinautomuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9291038243856928640&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "martin-auto-museum-and-event-center",
      "poi_latitude": "33.6122996",
      "poi_longitude": "-112.1525224",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 602-298-2377",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0218-d612-747f-818f-cabff3839243.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-d612-747f-818f-cabff3839243",
        "storage_key": "property/6767906449167150/019d0218-d612-747f-818f-cabff3839243.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJLetTmuFuK4cRgE-phw5m8IA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_57738773-1b22-471d-9ae3-a3474a904aad",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "custom",
      "poi_name": "Global Credit Union Arena",
      "poi_type": "Entertainment",
      "poi_address": "3300 W Camelback Rd Building 38, Phoenix, AZ 85017, USA",
      "poi_short_description": "Medium-sized arena at Grand Canyon University seating 7,000, staging concerts and basketball games.",
      "poi_long_description": "People say this arena is a great place to watch basketball and host events like graduations and orientations. They highlight the spaciousness, ideal size for viewing, and fun atmosphere, especially during games. They also like the welcoming staff and students.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0219-18fd-711b-941e-74685cce059d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0219-18fd-711b-941e-74685cce059d",
        "storage_key": "property/6767906449167150/019d0219-18fd-711b-941e-74685cce059d.webp",
        "width": 1136,
        "height": 712
      },
      "poi_business_url": "http://www.gcuarena.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17774516067949477999&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "global-credit-union-arena",
      "poi_latitude": "33.5097451",
      "poi_longitude": "-112.1286043",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 602-639-8979",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0218-d264-771b-9ddb-8894427d400b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-d264-771b-9ddb-8894427d400b",
        "storage_key": "property/6767906449167150/019d0218-d264-771b-9ddb-8894427d400b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5e8isk8TK4cRbwCavDDEq_Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_9dfdec5d-d11b-4019-9654-a23b6159c589",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "custom",
      "poi_name": "Stratosphere Adventure Park",
      "poi_type": "Entertainment",
      "poi_address": "5665 W Bell Rd, Glendale, AZ 85308, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this amusement park offers a variety of fun activities, including trampolines, slides, and a rock wall. They highlight the clean and spacious facility, and the friendly and helpful staff. They also like the affordable prices and the fun, family-friendly atmosphere.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://stratosphereadventurepark.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5909811527245393997&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "stratosphere-adventure-park",
      "poi_latitude": "33.6374257",
      "poi_longitude": "-112.1805447",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 602-767-4737",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0218-d264-771b-9ddb-8894427d400b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-d264-771b-9ddb-8894427d400b",
        "storage_key": "property/6767906449167150/019d0218-d264-771b-9ddb-8894427d400b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgWzZLvhpK4cRTXD4wkXeA1I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_93a9dd4f-abc1-4601-a6fa-53cd869f9434",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "custom",
      "poi_name": "River Ranch Water Park",
      "poi_type": "Entertainment",
      "poi_address": "7667 N 18th Pl, Phoenix, AZ 85020, USA",
      "poi_short_description": "Water park featuring a lazy river, along with mini-golf and a restaurant.",
      "poi_long_description": "Visitors say this water park has a lazy river, a waterslide, and a pool with a volleyball net and waterfall. They also highlight the availability of cabana rentals, day passes, and towels.\n\nSome reviews mention the food can be overpriced.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15631802649349206176&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "river-ranch-water-park",
      "poi_latitude": "33.5486089",
      "poi_longitude": "-112.0439762",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 21 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0218-d264-771b-9ddb-8894427d400b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-d264-771b-9ddb-8894427d400b",
        "storage_key": "property/6767906449167150/019d0218-d264-771b-9ddb-8894427d400b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMfYjWxBzK4cRoDB4UbBR79g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "water_park"
    },
    {
      "id": "custom_d016e30c-e079-4c77-9f6c-7abd8f1f5f1c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "custom",
      "poi_name": "EōS Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "2814 W Bell Rd Ste 1490, Phoenix, AZ 85053, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym has a wide variety of new, smart, and easy-to-learn equipment, and they appreciate the spacious layout. They also highlight that the gym doesn't feel crowded, even when it's busy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0219-18fd-711b-941e-715d788f13a7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0219-18fd-711b-941e-715d788f13a7",
        "storage_key": "property/6767906449167150/019d0219-18fd-711b-941e-715d788f13a7.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.eosfitness.com/gym/phoenix-i-17-w-bell-rd?utm_source=local&utm_medium=organic&utm_campaign=evergreen_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=1261832207160007351&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "es-fitness",
      "poi_latitude": "33.6415647",
      "poi_longitude": "-112.1195696",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 480-648-0003",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0218-d264-771b-9ddb-8894427d400b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-d264-771b-9ddb-8894427d400b",
        "storage_key": "property/6767906449167150/019d0218-d264-771b-9ddb-8894427d400b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJea0loVvK4cRt1rr-bTtghE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_94fc78ca-93cd-4fcf-97bf-e9cacfbe84f3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "custom",
      "poi_name": "VASA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "4255 W Thunderbird Rd, Phoenix, AZ 85053, USA",
      "poi_short_description": "Roomy chain facility for gym regulars featuring cardio and weight machines, an indoor pool, free weights and group classes.",
      "poi_long_description": "People say this gym offers a wide variety of equipment, classes, and training options, and has amenities like a pool, sauna, and steam room. They also highlight the clean facilities, friendly and helpful staff, and the positive, energetic vibe.\n\nSome reviews mention the equipment can be broken.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0219-1e6d-760d-b77d-207f74c5acdc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0219-1e6d-760d-b77d-207f74c5acdc",
        "storage_key": "property/6767906449167150/019d0219-1e6d-760d-b77d-207f74c5acdc.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://vasafitness.com/locations/az/phoenix-thunderbird/?utm_medium=organic&utm_source=GMBlisting&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=1906049609365793961&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "vasa-fitness",
      "poi_latitude": "33.6094223",
      "poi_longitude": "-112.150361",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 602-603-0811",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0218-d264-771b-9ddb-8894427d400b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-d264-771b-9ddb-8894427d400b",
        "storage_key": "property/6767906449167150/019d0218-d264-771b-9ddb-8894427d400b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJd65gug1pK4cRqSyFYgWmcxo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_67795643-985c-44d8-a08d-5ad825bf0f61",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1625 W Camelback Rd, Phoenix, AZ 85015, USA",
      "poi_short_description": "Workout facility equipped with cardio machines, dumbbells and free weights, plus massage chairs.",
      "poi_long_description": "People say this gym offers a variety of equipment and is conveniently located. They also highlight the gym is clean and the staff is friendly and helpful.\n\nOther reviews mention the gym can be closed due to power outages.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0218-a20b-731e-be81-c6bb2b4e2908.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0218-a20b-731e-be81-c6bb2b4e2908",
        "storage_key": "property/6767906449167150/019d0218-a20b-731e-be81-c6bb2b4e2908.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/phoenix-alhambra-az?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=2585588648961876717&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "33.5082027",
      "poi_longitude": "-112.0950049",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 32 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 602-374-4341",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0218-d264-771b-9ddb-8894427d400b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-d264-771b-9ddb-8894427d400b",
        "storage_key": "property/6767906449167150/019d0218-d264-771b-9ddb-8894427d400b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRSpSWd8SK4cR7aKnXC3b4SM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_9c2ea21f-26c0-4535-896e-7965b2edec19",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "custom",
      "poi_name": "LA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "710 W Camelback Rd, Phoenix, AZ 85013, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers a wide variety of well-maintained equipment, including cardio machines, weights, and machines, as well as group fitness classes. They also highlight the clean facilities, friendly and helpful staff, and positive atmosphere.\n\nOther reviews mention the gym can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0219-2009-7056-a343-a257442c35fa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0219-2009-7056-a343-a257442c35fa",
        "storage_key": "property/6767906449167150/019d0219-2009-7056-a343-a257442c35fa.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.lafitness.com/Pages/clubhome.aspx?clubid=912&utm_source=google&utm_medium=googlemaps&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=11806943131661403877&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "la-fitness",
      "poi_latitude": "33.5114008",
      "poi_longitude": "-112.0833713",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 43 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 602-282-0243",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0218-d264-771b-9ddb-8894427d400b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-d264-771b-9ddb-8894427d400b",
        "storage_key": "property/6767906449167150/019d0218-d264-771b-9ddb-8894427d400b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZS1aJcMSK4cR5Ybq7Tiw2qM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_6139d1a5-2407-407b-b204-9915323a2abc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "custom",
      "poi_name": "Element Nail Bar",
      "poi_type": "Health and Wellness",
      "poi_address": "6022 N 16th St, Phoenix, AZ 85016, USA",
      "poi_short_description": "Nail salon in Sunbrite Corner offering a wide range of nail services, as well as spa treatments.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0219-207c-767e-abac-b3792aba33cb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0219-207c-767e-abac-b3792aba33cb",
        "storage_key": "property/6767906449167150/019d0219-207c-767e-abac-b3792aba33cb.webp",
        "width": 1280,
        "height": 832
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17767652852326011484&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "element-nail-bar",
      "poi_latitude": "33.5245619",
      "poi_longitude": "-112.0478033",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 42 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 602-607-5686",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0218-d264-771b-9ddb-8894427d400b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-d264-771b-9ddb-8894427d400b",
        "storage_key": "property/6767906449167150/019d0218-d264-771b-9ddb-8894427d400b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuSItbchBK4cRXBJZ0yFik_Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_5c8ed272-40e8-4174-9966-201c48333e55",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "custom",
      "poi_name": "Banner Thunderbird Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "5555 W Thunderbird Rd, Glendale, AZ 85306, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0218-9c88-7056-8b9b-0d0dc783d537.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0218-9c88-7056-8b9b-0d0dc783d537",
        "storage_key": "property/6767906449167150/019d0218-9c88-7056-8b9b-0d0dc783d537.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.bannerhealth.com/locations/glendale/banner-thunderbird-medical-center?y_source=1_MTE5MDczNTItNzE1LWxvY2F0aW9uLndlYnNpdGU=",
      "poi_directions_map_url": "https://maps.google.com/?cid=11031221542305799944&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "banner-thunderbird-medical-center",
      "poi_latitude": "33.6093624",
      "poi_longitude": "-112.1801493",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 602-865-5555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0218-d61c-77bc-ae64-2f57b80d836a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-d61c-77bc-ae64-2f57b80d836a",
        "storage_key": "property/6767906449167150/019d0218-d61c-77bc-ae64-2f57b80d836a.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJnx4Z3nFpK4cRCB_G-4vFFpk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_5776790b-c636-42c5-8164-25013fada9a1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "custom",
      "poi_name": "HonorHealth Deer Valley Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "19829 N 27th Ave, Phoenix, AZ 85027, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0219-2255-753a-831b-931cafa53b21.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0219-2255-753a-831b-931cafa53b21",
        "storage_key": "property/6767906449167150/019d0219-2255-753a-831b-931cafa53b21.webp",
        "width": 800,
        "height": 300
      },
      "poi_business_url": "https://www.honorhealth.com/locations/hospitals/deer-valley-medical-center?utm_source=GMB&utm_medium=local&utm_campaign=Valley_Medical_Center",
      "poi_directions_map_url": "https://maps.google.com/?cid=15230205930965625593&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "honorhealth-deer-valley-medical-center",
      "poi_latitude": "33.6655324",
      "poi_longitude": "-112.1164943",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 623-879-6100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0218-d61c-77bc-ae64-2f57b80d836a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-d61c-77bc-ae64-2f57b80d836a",
        "storage_key": "property/6767906449167150/019d0218-d61c-77bc-ae64-2f57b80d836a.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6fTTNBRvK4cR-epA45mPXNM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_22a238c2-921e-4a8b-83ff-2de07928c306",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "custom",
      "poi_name": "Sahuaro Ranch Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9802 59th Ave, Glendale, AZ 85302, USA",
      "poi_short_description": "Set on old ranch grounds, this park features wandering fowl, a historic house museum & play areas.",
      "poi_long_description": "People say this park offers a playground, rose garden, historic buildings, and opportunities for picnics and barbecues. They highlight the beautiful grounds, the presence of peacocks and bunnies, and the family-friendly atmosphere. They also like the peaceful and relaxing vibe, and the opportunities for walking and enjoying the weather. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0219-22d5-7048-a5a3-d2fc2172c7f2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0219-22d5-7048-a5a3-d2fc2172c7f2",
        "storage_key": "property/6767906449167150/019d0219-22d5-7048-a5a3-d2fc2172c7f2.webp",
        "width": 1200,
        "height": 900
      },
      "poi_business_url": "http://www.glendaleaz.com/parksandrecreation/sahuaroranchpark.cfm",
      "poi_directions_map_url": "https://maps.google.com/?cid=12960466992835098622&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sahuaro-ranch-park",
      "poi_latitude": "33.5765875",
      "poi_longitude": "-112.1906328",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 623-930-2820",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0218-d659-720a-9c14-7896cbe86bee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-d659-720a-9c14-7896cbe86bee",
        "storage_key": "property/6767906449167150/019d0218-d659-720a-9c14-7896cbe86bee.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJQbuutctrK4cR_ncc_w_U3LM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_9597ae25-39b4-45cd-9803-217c4e5caa41",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "custom",
      "poi_name": "Dreamy Draw Recreation Area",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2421 E Northern Ave, Phoenix, AZ 85020, USA",
      "poi_short_description": "Expansive public park with miles of hiking & biking trails winding through rocky desert terrain.",
      "poi_long_description": "Hikers say this recreation area offers a wide variety of trails for all levels, from paved paths suitable for strollers and bikes to challenging hikes with scenic views. They also highlight the clean restrooms, ample parking, and plentiful water fountains, making it a convenient and enjoyable spot for outdoor activities.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.phoenix.gov/parks/trails/locations/piestewa-peak",
      "poi_directions_map_url": "https://maps.google.com/?cid=4114834764206794336&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "dreamy-draw-recreation-area",
      "poi_latitude": "33.5642105",
      "poi_longitude": "-112.0288628",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 45 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 602-262-7901",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0218-d264-771b-9ddb-8894427d400b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-d264-771b-9ddb-8894427d400b",
        "storage_key": "property/6767906449167150/019d0218-d264-771b-9ddb-8894427d400b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_____xgSK4cRYGb5rWrUGjk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "custom_665d120d-df3d-461c-b33a-062255d00062",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "custom",
      "poi_name": "Phoenix Mountains Preserve",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2701 Piestewa Peak Dr, Phoenix, AZ 85016, USA",
      "poi_short_description": "Group of parks with mountain & desert hiking trails, plus an abundance of cacti & native wildlife.",
      "poi_long_description": "People say this nature preserve offers a variety of trails for hiking, biking, and walking, with options for all levels of ability. They highlight the beautiful desert scenery, stunning views, and opportunities for solitude, especially on less popular trails. They also like the well-marked and maintained trails, and the availability of amenities such as restrooms and water bottle filling stations. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0219-250a-728e-952b-5b6d355cf407.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0219-250a-728e-952b-5b6d355cf407",
        "storage_key": "property/6767906449167150/019d0219-250a-728e-952b-5b6d355cf407.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.phoenix.gov/parks/trails/locations/piestewa-peak",
      "poi_directions_map_url": "https://maps.google.com/?cid=768664447671239094&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "phoenix-mountains-preserve",
      "poi_latitude": "33.5620742",
      "poi_longitude": "-112.0209097",
      "poi_miles_from_property": "8.2",
      "poi_walking_minutes": "3 hours 5 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 602-261-8318",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0218-d659-720a-9c14-7896cbe86bee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-d659-720a-9c14-7896cbe86bee",
        "storage_key": "property/6767906449167150/019d0218-d659-720a-9c14-7896cbe86bee.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8UYsGO1yK4cRtoHqGj7Yqgo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "custom_cf2ee0f6-bc30-45a6-8672-6d582b8ac86a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "custom",
      "poi_name": "North Mountain Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "10608 N 7th St, Phoenix, AZ 85020, USA",
      "poi_short_description": "Hiking trails of varying difficulty lead to 2 summits for scenic views, plus a visitor center.",
      "poi_long_description": "Hikers say this park offers a variety of trails for all skill levels, with stunning views of the city and mountains. They also highlight the ample parking, clean facilities, and dog-friendly atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0219-2642-7073-9214-d37d0fc93eec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0219-2642-7073-9214-d37d0fc93eec",
        "storage_key": "property/6767906449167150/019d0219-2642-7073-9214-d37d0fc93eec.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.phoenix.gov/parkssite/Pages/North-Mountain-Shaw-Butte-Trails.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=7071528748687554906&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "north-mountain-park",
      "poi_latitude": "33.5852154",
      "poi_longitude": "-112.0709411",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 602-262-7901",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0218-d659-720a-9c14-7896cbe86bee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-d659-720a-9c14-7896cbe86bee",
        "storage_key": "property/6767906449167150/019d0218-d659-720a-9c14-7896cbe86bee.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJM7fi5ZdtK4cRWvl7LO4dI2I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_114c8d06-c8ae-42ab-83c7-94d2bcb6279b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "custom",
      "poi_name": "Bellair Golf Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "17233 N 45th Ave, Glendale, AZ 85308, USA",
      "poi_short_description": "Golf course with an 18-hole short course and driving range, plus an on-site restaurant.",
      "poi_long_description": "People say this golf course offers a fun, short course perfect for practicing irons and a driving range with ball tracking technology. They highlight the well-maintained greens, fluffy white sand in the bunkers, and the friendly and helpful staff. They also like the reasonable prices and relaxing vibe.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0219-2813-7683-92d9-1f0cad1f6137.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0219-2813-7683-92d9-1f0cad1f6137",
        "storage_key": "property/6767906449167150/019d0219-2813-7683-92d9-1f0cad1f6137.webp",
        "width": 702,
        "height": 395
      },
      "poi_business_url": "https://www.bellairgolfpark.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8406907117581785615&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bellair-golf-park",
      "poi_latitude": "33.6428631",
      "poi_longitude": "-112.1567792",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 602-513-7070",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0219-38ec-727e-a003-520e235c52db.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0219-38ec-727e-a003-520e235c52db",
        "storage_key": "property/6767906449167150/019d0219-38ec-727e-a003-520e235c52db.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3deUYXVpK4cRD1oqU3tVq3Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_68125fb6-d86f-4adf-a9ab-1bd60303b8a6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "custom",
      "poi_name": "19th Ave/Dunlap",
      "poi_type": "Transportation & Transit",
      "poi_address": "1901 W Dunlap Ave, Phoenix, AZ 85021, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0219-2ad4-73fe-a315-2282e110e882.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0219-2ad4-73fe-a315-2282e110e882",
        "storage_key": "property/6767906449167150/019d0219-2ad4-73fe-a315-2282e110e882.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.valleymetro.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10720189826567534372&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "19th-avedunlap",
      "poi_latitude": "33.567376",
      "poi_longitude": "-112.10084",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 602-253-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0218-d264-771b-9ddb-8894427d400b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-d264-771b-9ddb-8894427d400b",
        "storage_key": "property/6767906449167150/019d0218-d264-771b-9ddb-8894427d400b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJoYFO8lVsK4cRJHdQadnDxZQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_65c46501-1369-4f90-9ae7-364305d58b6d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "custom",
      "poi_name": "19th Ave/Camelback",
      "poi_type": "Transportation & Transit",
      "poi_address": "Phoenix, AZ 85015, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0219-2a90-7639-9797-da8d22be36ac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0219-2a90-7639-9797-da8d22be36ac",
        "storage_key": "property/6767906449167150/019d0219-2a90-7639-9797-da8d22be36ac.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17720015484194380135&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "19th-avecamelback",
      "poi_latitude": "33.5095401",
      "poi_longitude": "-112.098769",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0218-d264-771b-9ddb-8894427d400b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-d264-771b-9ddb-8894427d400b",
        "storage_key": "property/6767906449167150/019d0218-d264-771b-9ddb-8894427d400b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJU3szwiYTK4cRZ9nTvTIk6vU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_d4756849-5ae2-4c4a-9736-c6a2c9d6583d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "custom",
      "poi_name": "Metro Pkwy",
      "poi_type": "Transportation & Transit",
      "poi_address": "Phoenix, AZ 85051, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0218-bac0-7252-8002-eb8a66af248b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0218-bac0-7252-8002-eb8a66af248b",
        "storage_key": "property/6767906449167150/019d0218-bac0-7252-8002-eb8a66af248b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=3095258421458371006&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "metro-pkwy",
      "poi_latitude": "33.575092",
      "poi_longitude": "-112.118469",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0218-d264-771b-9ddb-8894427d400b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-d264-771b-9ddb-8894427d400b",
        "storage_key": "property/6767906449167150/019d0218-d264-771b-9ddb-8894427d400b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJh7kvo0JsK4cRvgEQiyKR9Co",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_e025405b-3bf5-4ff6-b96e-a913e2417c8e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "custom",
      "poi_name": "Glendale/19th Ave",
      "poi_type": "Transportation & Transit",
      "poi_address": "Phoenix, AZ 85021, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17712783669072054624&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "glendale19th-ave",
      "poi_latitude": "33.537456",
      "poi_longitude": "-112.099688",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0218-d264-771b-9ddb-8894427d400b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-d264-771b-9ddb-8894427d400b",
        "storage_key": "property/6767906449167150/019d0218-d264-771b-9ddb-8894427d400b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJK_VaEtlsK4cRYElhkuZy0PU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_3d3cd7fc-fd8e-4a0b-8e07-9969df33d55d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "custom",
      "poi_name": "7th Ave/Camelback",
      "poi_type": "Transportation & Transit",
      "poi_address": "Phoenix, AZ 85013, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0219-2cb2-701b-a358-3aadb8d0c171.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0219-2cb2-701b-a358-3aadb8d0c171",
        "storage_key": "property/6767906449167150/019d0219-2cb2-701b-a358-3aadb8d0c171.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=4500065263222447988&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "7th-avecamelback",
      "poi_latitude": "33.509307",
      "poi_longitude": "-112.083348",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 42 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0218-d264-771b-9ddb-8894427d400b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-d264-771b-9ddb-8894427d400b",
        "storage_key": "property/6767906449167150/019d0218-d264-771b-9ddb-8894427d400b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9TQ0ztwSK4cRdN9yuINxcz4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_a3593d3b-5c5f-459c-aeda-472df6056395",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "custom",
      "poi_name": "PetSmart Corporate Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "19601 N 27th Ave, Phoenix, AZ 85027, USA",
      "poi_short_description": "Chain featuring a range of pets, supplies & food (most offer grooming, boarding & other services).",
      "poi_long_description": "Chain featuring a range of pets, supplies & food (most offer grooming, boarding & other services).",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://pets.petsmart.com/help/contact-us/contact-corporate.shtml",
      "poi_directions_map_url": "https://maps.google.com/?cid=11160285302803478114&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "petsmart-corporate-office",
      "poi_latitude": "33.663657",
      "poi_longitude": "-112.1159034",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 888-839-9638",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0218-d264-771b-9ddb-8894427d400b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-d264-771b-9ddb-8894427d400b",
        "storage_key": "property/6767906449167150/019d0218-d264-771b-9ddb-8894427d400b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMaK89BZvK4cRYjadaVpM4Zo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_e60913bb-b9b2-4481-9736-de05d600e165",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "custom",
      "poi_name": "Honeywell Aerospace Technologies - Deer Valley",
      "poi_type": "Major Employers & Offices",
      "poi_address": "21111 N 19th Ave, Phoenix, AZ 85027, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0219-2cb2-701b-a358-33c83efdbecd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0219-2cb2-701b-a358-33c83efdbecd",
        "storage_key": "property/6767906449167150/019d0219-2cb2-701b-a358-33c83efdbecd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=404546493164785334&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "honeywell-aerospace-technologies---deer-valley",
      "poi_latitude": "33.6795907",
      "poi_longitude": "-112.09847",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0218-d264-771b-9ddb-8894427d400b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-d264-771b-9ddb-8894427d400b",
        "storage_key": "property/6767906449167150/019d0218-d264-771b-9ddb-8894427d400b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJR2rtYXZvK4cRto43ZOQ8nQU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_9b7200ea-7a02-4078-b19f-75da879e5d60",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "custom",
      "poi_name": "Maricopa Ambulance",
      "poi_type": "Major Employers & Offices",
      "poi_address": "10243 N 19th Ave B, Phoenix, AZ 85021, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0219-2ffc-7004-b932-efe127dd28fc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0219-2ffc-7004-b932-efe127dd28fc",
        "storage_key": "property/6767906449167150/019d0219-2ffc-7004-b932-efe127dd28fc.webp",
        "width": 1280,
        "height": 725
      },
      "poi_business_url": "https://www.maricopaambulance.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12641644849842697492&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "maricopa-ambulance",
      "poi_latitude": "33.579714",
      "poi_longitude": "-112.09836",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 480-485-2900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0218-d264-771b-9ddb-8894427d400b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-d264-771b-9ddb-8894427d400b",
        "storage_key": "property/6767906449167150/019d0218-d264-771b-9ddb-8894427d400b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJd9rip01sK4cRFDWFOwMlcK8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_f5aef26d-7289-475d-ab8c-d0cd340e135f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "custom",
      "poi_name": "Goodwill Corporate Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2626 W Beryl Ave, Phoenix, AZ 85021, USA",
      "poi_short_description": "Long-standing nonprofit chain with a range of pre-owned clothing, housewares & more.",
      "poi_long_description": "Long-standing nonprofit chain with a range of pre-owned clothing, housewares & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0219-30a4-71c0-82fe-2924d299b3a9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0219-30a4-71c0-82fe-2924d299b3a9",
        "storage_key": "property/6767906449167150/019d0219-30a4-71c0-82fe-2924d299b3a9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.goodwillaz.org/contact/?utm_source=local&utm_medium=organic&utm_campaign=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=260774468439883183&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "goodwill-corporate-center",
      "poi_latitude": "33.5799154",
      "poi_longitude": "-112.115543",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 602-535-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0218-d264-771b-9ddb-8894427d400b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-d264-771b-9ddb-8894427d400b",
        "storage_key": "property/6767906449167150/019d0218-d264-771b-9ddb-8894427d400b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdYG0fUFsK4cRr73ZVf90ngM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_dac5a5c9-62cf-433e-b5ef-de56cd5b97a8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "custom",
      "poi_name": "Best Western Global Operations Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "20400 N 29th Ave, Phoenix, AZ 85027, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.bestwestern.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7496207644875558879&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "best-western-global-operations-center",
      "poi_latitude": "33.6722755",
      "poi_longitude": "-112.1224594",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 602-957-4200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0218-d264-771b-9ddb-8894427d400b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-d264-771b-9ddb-8894427d400b",
        "storage_key": "property/6767906449167150/019d0218-d264-771b-9ddb-8894427d400b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmRT4B0FvK4cR3w9g6yLhB2g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "ec_33ec39d1d3e98d449eae05fa",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "day": "MON",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_fbf7ae367972e5e545c62130",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "day": "TUE",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_29e85640e4e5a7e0dd12d682",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "day": "THU",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_762fba80ae1787c9b5bd22fc",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "day": "FRI",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_a994f323f65722ced9628ee4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "day": "WED",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_caa2f011235ba2322b296bc1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_080688df-96fb-4bb9-bcca-180fab98b05e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "rating": "5.0",
      "name": "Marissa Nava",
      "text": "Arlene is always kind, professional and quick to help with anything that comes up. You can tell that they really care about the residents and are pride in keeping the community running smoothly. It makes all the difference having someone who is approachable and easy to talk to.",
      "date": "2025-10-24",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_3d34c161-f5bf-46d5-9d5b-0b9ce39b4c7f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0219-dcb2-731a-881d-186b787d110e.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Fitness center with cardio equipment like treadmills and ellipticals.",
        "public_id": "019d0219-dcb2-731a-881d-186b787d110e",
        "storage_key": "property/6767906449167150/019d0219-dcb2-731a-881d-186b787d110e.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Motif | Gym",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=RkAgD3R2Y5q"
    },
    {
      "id": "custom_4f94f07b-c365-4012-83f3-edfcbf0fd898",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0219-dccd-7458-ac73-5b173e1fb893.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Kitchen and laundry area with washer and dryer.",
        "public_id": "019d0219-dccd-7458-ac73-5b173e1fb893",
        "storage_key": "property/6767906449167150/019d0219-dccd-7458-ac73-5b173e1fb893.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Motif | A1r | 1BR, 1BA - 689SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=ecfnDKpu4hi"
    },
    {
      "id": "custom_706f9143-49b4-4bed-86a4-0c3e109f7cc1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0219-dcb5-72b9-b1c1-a4a0a26ec2d0.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Kitchen and living room of an apartment with dining table in foreground.",
        "public_id": "019d0219-dcb5-72b9-b1c1-a4a0a26ec2d0",
        "storage_key": "property/6767906449167150/019d0219-dcb5-72b9-b1c1-a4a0a26ec2d0.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Motif | A2 Premium | 1BR, 1BA - 689 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=tVa2XXamRmu"
    },
    {
      "id": "custom_6d7b7c0c-ada4-4a4a-ae48-981bb6197640",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0219-dccd-7458-ac73-5f6e5d3c1330.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and a balcony view.",
        "public_id": "019d0219-dccd-7458-ac73-5f6e5d3c1330",
        "storage_key": "property/6767906449167150/019d0219-dccd-7458-ac73-5f6e5d3c1330.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Motif | B1r | 2BR, 2BA - 1004 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=u73DQCSvo7w"
    },
    {
      "id": "custom_8b15337d-f4d2-492e-9e86-44389166e19c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167150/019d0219-ea11-7788-8c0b-36ee921efe4b.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Kitchen and dining area with a table and chairs, leading to a living room.",
        "public_id": "019d0219-ea11-7788-8c0b-36ee921efe4b",
        "storage_key": "property/6767906449167150/019d0219-ea11-7788-8c0b-36ee921efe4b.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Motif | B2 Premium | 2BR, 2BA - 1004 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=ydcciz53a2Z"
    },
    {
      "id": "custom_3aabf8c7-559f-47ca-b234-de9831aadf89",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": null,
      "virtual_tour_thumbnail_media": null,
      "virtual_tour_title": "Virtual Tour",
      "virtual_tour_type": "",
      "virtual_tour_url": "https://my.matterport.com/show/?m=HtH7oTS31Zy"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019e23be-932b-72fb-aecf-9fe556474571",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Motif Website",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150"
    },
    {
      "lead_collector_id": "019e23be-93ab-74bc-8dc2-133275f07397",
      "lead_source": "LANDING_PAGE",
      "name": "Motif Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "generator",
      "page_item_url": "in-unit-laundry-apartments-north-mountain-village",
      "search_query": "in unit laundry apartments in North Mountain Village",
      "category": "Amenity",
      "h1_title": "In Unit Laundry Apartments in North Mountain",
      "h2_subtitle": "Enjoy the convenience of in unit laundry in North Mountain Village. Discover how Motif's amenities can enhance modern apartment living.",
      "page_copy": "Discover the ultimate convenience at Motif, where our in unit laundry apartments in North Mountain Village set a new standard for ease and comfort. Nestled in the vibrant community of North Mountain Village, our apartments are designed to make everyday tasks effortless, so you can spend more time enjoying life.\n\nAt Motif, our premium amenities go beyond just in unit laundry. Experience the comfort of our elegant interiors featuring updated light fixtures and plush carpeting. Bask in the peacefulness of our beautifully landscaped courtyard, or indulge in a freshly brewed beverage at our coffee bar. With ample storage space offered by walk-in closets, Motif combines style and practicality, providing a perfect haven in Maricopa County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In Unit Laundry Apartments in North Mountain",
      "seo_description": "Find in unit laundry apartments in North Mountain Village at Motif, offering modern amenities like walk-in closets and a coffee bar.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "generator",
      "page_item_url": "dog-friendly-apartments-phoenix-az-motif",
      "search_query": "dog friendly apartments in Phoenix AZ",
      "category": "Amenity",
      "h1_title": "Dog Friendly Apartments in Phoenix, AZ",
      "h2_subtitle": "Welcome to Motif, offering dog-friendly apartments in Phoenix, AZ. Discover a pet-friendly community in the heart of the North Mountain Village.",
      "page_copy": "At Motif, we understand that pets are family. That's why our dog-friendly apartments in Phoenix, AZ are designed with both you and your furry companions in mind. Situated in the welcoming North Mountain Village neighborhood, our community boasts spacious layouts with ample room for everyone in the family.\n\nOur pet-friendly environment is just one aspect of what makes living at Motif special. Residents enjoy updated light fixtures and spacious, walk-in closets, perfect for organizing all of life's necessities. For those who love social spaces, our courtyard offers a peaceful retreat, while the on-site coffee bar is the perfect spot to refuel. Experience the harmonious blend of comfort and convenience tailored to you and your pets in Maricopa County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog Friendly Apartments in Phoenix, AZ",
      "seo_description": "Enjoy dog-friendly apartments in Phoenix, AZ at Motif. Located in North Mountain Village with amenities like a courtyard and coffee bar.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "generator",
      "page_item_url": "luxury-apartments-with-pool-maricopa-county-motif",
      "search_query": "luxury apartments with pool in Maricopa County",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Pool in Maricopa County",
      "h2_subtitle": "Discover the ideal blend of comfort and luxury at Motif. Our luxury apartments with pool in Maricopa County offer an upscale living experience.",
      "page_copy": "Motif presents an unbeatable living experience with our luxury apartments featuring a pool in Maricopa County. Nestled in the desirable North Mountain Village, our community offers sophisticated amenities and elegant apartment finishes that elevate your lifestyle.\n\nOur resort-style living includes a serene courtyard perfect for relaxation and socializing. Inside, each apartment is adorned with updated light fixtures and plush carpet, creating a warm and inviting atmosphere. Enjoy the convenience of walk-in closets, ensuring ample storage for all your essentials. With a welcoming coffee bar on-site, Motif provides a blend of style, convenience, and community in one of Phoenix's most sought-after locations.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Pool in Maricopa County",
      "seo_description": "Explore luxury apartments with a pool in Maricopa County at Motif, featuring elegant interiors and top-tier amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "generator",
      "page_item_url": "air-conditioned-apartments-phoenix-85029-motif",
      "search_query": "air conditioned apartments in Phoenix 85029",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments in Phoenix 85029",
      "h2_subtitle": "Stay comfortable in our air-conditioned apartments at Motif, Phoenix 85029. Experience year-round comfort in the heart of the North Mountain Village.",
      "page_copy": "At Motif, located in the bustling area of Phoenix 85029, we prioritize your comfort. Our air-conditioned apartments ensure that you stay cool and relaxed all year long, making them the perfect choice for those seeking relief from the Arizona heat.\n\nBeyond our efficient climate control, our community offers a host of amenities to elevate your living experience. Enjoy spacious interiors finished with updated light fixtures and inviting carpeted floors. Our walk-in closets provide all the storage you need, and our beautiful courtyard offers a serene escape. Nestled in North Mountain Village, Motif invites you to explore an array of lifestyle conveniences, including our welcoming coffee bar, which completes your comfortable home environment.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apartments in Phoenix 85029",
      "seo_description": "Enjoy air-conditioned comfort at Motif in Phoenix 85029. Located in North Mountain Village with modern amenities like walk-in closets.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "generator",
      "page_item_url": "apartments-fitness-center-north-mountain-village-motif",
      "search_query": "apartments with fitness center in North Mountain Village",
      "category": "Amenity",
      "h1_title": "Apartments with Fitness Center in North Mountain",
      "h2_subtitle": "Experience active living at Motif, offering apartments with a fitness center in North Mountain Village. Enjoy convenience and community in Phoenix.",
      "page_copy": "Motif offers the perfect balance of fitness and modern living with our apartments featuring a fitness center right in North Mountain Village. Designed for those who value an active lifestyle, our community makes it easy to prioritize wellness without leaving home.\n\nBeyond fitness amenities, Motif provides a range of comforts designed to enhance your daily life. Inside our apartments, you'll find updated light fixtures and plush carpeting that create a cozy atmosphere. Walk-in closets offer generous storage space, ensuring an organized home. Relish the peaceful courtyard or energize at our on-site coffee bar, all situated in the vibrant heart of Phoenix’s North Mountain Village.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Fitness Center, North Mountain",
      "seo_description": "Discover Motif's apartments with a fitness center in North Mountain Village. Enjoy luxury amenities in a prime Phoenix location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-phoenix-az-motif",
      "search_query": "one bedroom apartments phoenix az",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Phoenix, AZ",
      "h2_subtitle": "Find your perfect one bedroom apartment at Motif in Phoenix, AZ. Enjoy modern amenities and a vibrant community in North Mountain Village.",
      "page_copy": "Welcome to Motif, where our one bedroom apartments in Phoenix, AZ offer the perfect blend of comfort and style. Located in the dynamic North Mountain Village, each apartment is thoughtfully designed with modern features and amenities that cater to your lifestyle needs.\n\nResidents at Motif enjoy spacious living areas highlighted by updated light fixtures and cozy carpeting. With ample storage provided by walk-in closets, organizing your space has never been easier. Relax in our inviting courtyard or sip a fresh brew at our community coffee bar. Experience the warmth and community of Motif, where we redefine apartment living in the heart of Phoenix, AZ.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Phoenix, AZ",
      "seo_description": "Explore Motif's one bedroom apartments in Phoenix, AZ with modern amenities. Ideal living in North Mountain Village with a community coffee bar.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-near-north-mountain-village-motif",
      "search_query": "two bedroom apartments near north mountain village",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments Near North Mountain",
      "h2_subtitle": "Discover spacious two bedroom apartments near North Mountain Village at Motif. Enjoy modern amenities and a prime Phoenix location.",
      "page_copy": "Located near the picturesque North Mountain Village, Motif offers exceptional two bedroom apartments designed for those seeking both space and convenience. Our community caters to a modern lifestyle, providing a perfect home base for exploring the vibrant Phoenix area.\n\nOur two bedroom apartments feature modern touches like updated light fixtures and plush carpeting, creating a warm and inviting ambiance. The expansive walk-in closets and elegant courtyard redefine comfortable living. Take advantage of our community coffee bar, perfect for connecting with neighbors. Experience the blend of style and function at Motif, where North Mountain Village's beauty is just a step away.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments Near North Mountain",
      "seo_description": "Explore Motif's two bedroom apartments near North Mountain Village. Enjoy spacious living with modern amenities in Phoenix, AZ.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167150",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-maricopa-county-motif",
      "search_query": "three bedroom apartments maricopa county",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments in Maricopa County",
      "h2_subtitle": "Explore spacious three bedroom apartments at Motif located in Maricopa County. Enjoy modern amenities and ample living space in vibrant Phoenix.",
      "page_copy": "At Motif, our three bedroom apartments in Maricopa County offer an ideal mix of space and style, catering to families and roommates alike. Situated in the welcoming North Mountain Village neighborhood, our community provides easy access to Phoenix's attractions while offering the serenity you desire.\n\nInside each apartment, you'll discover thoughtful touches such as updated light fixtures, plush carpeting, and ample walk-in closets that make organizing simple. Our tranquil courtyard and inviting coffee bar contribute to a community-focused atmosphere. Embrace the perfect balance of comfort and convenience at Motif, where modern living meets Maricopa County's stunning landscapes.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments in Maricopa County",
      "seo_description": "Discover Motif's three bedroom apartments in Maricopa County. Enjoy modern comforts and spacious living in the heart of Phoenix, AZ.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_pixel_id",
      "type": "STRING",
      "value": "1035508496598043"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "11309019620"
    },
    {
      "ID": "custom_text_us_url",
      "type": "STRING",
      "value": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=6237383560"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-T5QHRMLJ"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 3"
    },
    {
      "ID": "custom_rentgrata_token",
      "type": "STRING",
      "value": "fdd3345f-ebc9-43ef-b238-1639b1dca80a"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Rise"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_pricing_verbiage",
      "type": "STRING",
      "value": "<strong>Featuring all-in-pricing.</strong> One total price, no hidden fees - just full transparency. With everything clearly listed so you can budget with certainty. Customize by adding parking, animals, and more."
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/f6311774-1fe0-4f87-92fb-a10bc0dcd8db/app.js?property=f6311774-1fe0-4f87-92fb-a10bc0dcd8db&propertyName=Motif&channelUuid=c2490bd4-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345\" defer></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "47754697593"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IjJLZkM3R1F3ejVhNGlERDUvT2poUkE9PSIsInZhbHVlIjoiY2xtWlBTM0hvUzdFenNvMnF6Yncxdz09IiwibWFjIjoiNzY5OWE0MjM5YTc2ZDJkODUzNTcwYTFhZWYwMzUyY2EwNDc2MDkzNTY0OTEwY2FiZWY3MTVkMGRiYjNhZmMxMCJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_pixel_id": "1035508496598043",
  "custom_repli_id": "11309019620",
  "custom_text_us_url": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=6237383560",
  "custom_google_gtm_id": "GTM-T5QHRMLJ",
  "custom_rollout_phase": "Phase 3",
  "custom_rentgrata_token": "fdd3345f-ebc9-43ef-b238-1639b1dca80a",
  "custom_vibesites_theme": "Rise",
  "custom_ads_subscription": "none",
  "custom_pricing_verbiage": "<strong>Featuring all-in-pricing.</strong> One total price, no hidden fees - just full transparency. With everything clearly listed so you can budget with certainty. Customize by adding parking, animals, and more.",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/f6311774-1fe0-4f87-92fb-a10bc0dcd8db/app.js?property=f6311774-1fe0-4f87-92fb-a10bc0dcd8db&propertyName=Motif&channelUuid=c2490bd4-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345\" defer></script>",
  "custom_seo_subscription": "none",
  "custom_hubspot_company_id": "47754697593",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IjJLZkM3R1F3ejVhNGlERDUvT2poUkE9PSIsInZhbHVlIjoiY2xtWlBTM0hvUzdFenNvMnF6Yncxdz09IiwibWFjIjoiNzY5OWE0MjM5YTc2ZDJkODUzNTcwYTFhZWYwMzUyY2EwNDc2MDkzNTY0OTEwY2FiZWY3MTVkMGRiYjNhZmMxMCJ9",
  "custom_audioeye_site_id": "c4d60616-968b-4812-adb5-a98d1b264180",
  "custom_audioeye_site_hash": "4b10423b6b878c0c75bb071d75dfddc5"
};

export const generatedAt = '2026-10-27T17:10:18.344Z';
